import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import { MasterService } from '../../@core/services/master.service';
import { of, Subject } from 'rxjs';
import { catchError, take, takeUntil } from 'rxjs/operators';
import { NbToastrService } from '@nebular/theme';
import { ExportService } from '../../@core/services/export.service';
import { interval } from 'rxjs';
import { MenuService } from '../pages-menu';
import * as pdfjsLib from 'pdfjs-dist';
// Setup the worker
(pdfjsLib as any).GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${(pdfjsLib as any).version}/pdf.worker.min.js`;




@Component({
  selector: 'ngx-dashboard-engineer',
  templateUrl: './dashboard-engineer.component.html',
  styleUrls: ['./dashboard-engineer.component.scss']
})
export class DashboardEngineerComponent implements OnInit, OnDestroy {
  @ViewChild('upload_input', { static: false }) uploadInputRef!: ElementRef;
  @ViewChild('upload_avd_input') uploadAvdInputRef!: ElementRef;
  @ViewChild('aiScrubbingModal', { static: false }) aiScrubbingModalTemplate!: TemplateRef<any>;
  private destroy$ = new Subject<void>();
  private refreshSubscription$ = new Subject<void>();
  form!: FormGroup;
  currentPage: number = 1;
  itemsPerPage: number = 10;
  paginateData: any;
  paginatestartIndex: number = 0
  paginateendIndex: number = 10
  firstItemIndex: number = 1;
  lastItemIndex: number = 0;
  tableDataLength: number = 0;
  paginationData: any;
  searchInput: any = '';
  // selectedCustomerName: any = "";
  selectedEngineer: any = "";
  selectedCurrentStage: any = "";
  fromRfqDate: any = '';
  toRfqDate: any = '';
  selectedRfqDate: any = "";
  showModalECD: boolean = false; // ECD modal visibility flag
  showModalRFQ: boolean = false; // RFQ modal visibility flag
  showApprovalModal: boolean = false; // Approval modal visibility flag
  selectedApprovalProject: any = null; // Store selected project for approval
  projectStatuses: any[] = [];
  selectedApprovalStatus: string = 'Pending - Manager Review';

  fromExpectedCompletionDate: any = '';
  toExpectedCompletionDate: any = '';
  selectedExpetedCompletionDate: any = "";
  matchedCustomerData: any[] = []; // To store the matching result
  modalRef: NgbModalRef | null = null;
  customerModalRef: NgbModalRef | null = null;
  aiScrubbingModalRef: NgbModalRef | null = null;
  projectForm!: FormGroup;
  customerForm!: FormGroup;
  isProjectNameDuplicate: boolean = false;
  isCustomerNameDuplicate: boolean = false;
  isSaving: boolean = false;
  isExpectedCompletionDateDisabled: boolean = true;
  showAddButton: boolean = false;
  showQn2: boolean = false;
  showQn3: boolean = false;
  showDutyInput: boolean = false;
  dutyValuePercentage: number = 0;
  onQn123: any = { q1: null, q2: null, q3: null };
  engineersData: any[] = [];
  managerId: number | null = null;
  selectedCustomerId: number | null = null;
  selectedmatchedCustomerData: any = null;
  maxToday: string = '';
  nextMaxDate: string = '';
  currentDate: string = '';
  assignDate: string = '';
  previousStage: string | null = null;
  selectedCustomerName: string = '';
  statusFilter: string | null = null;
  allCostingProjects: any[] = [];
  allProcurementProjects: any[] = [];
  searchText: string = '';
  showAddCustomerButton: boolean = false;
  sourcingListFiles: File[] = [];
  alternatePartFiles: File[] = [];
  allManufacturerDetails: any[] = [];
  finalDataList: any = [];
  isUploadEnabled: boolean = false; // Initially, the Upload button is disabled.
  // Criteria object to hold form data
  criteria = {
    stockAvailability: false,
    leadTime: false,
    minimumPrice: false,
    authorisedSuppliers: false,
    selectedSuppliers: [],
  };
  // projectNameDetails: any[];
  projectNameDetails: string[] = [];

  buttonColorMap: { [key: string]: string } = {};

  allManufacturerDetailsMap: { [key: string]: any[] } = {};
  isButtonHidden: { [key: string]: boolean } = {};

  showDropdownMap: { [key: string]: boolean } = {};
  selectedManufacturer: { [key: string]: string } = {};  // Store selected manufacturer
  buttonBorderStyle: { [key: string]: string } = {};  // Store border styles
  isDropdownVisible: { [key: string]: boolean } = {};
  selectedManufacturerMap: { [key: string]: string } = {};
  manufacturerOverrideMap: { [key: string]: string } = {};
  thisMonthProjects: any[] = [];


  // Mock data for supplier dropdown
  supplierOptions = [
    { id: 1, name: 'DigiKey' },
    { id: 2, name: 'element14 APAC' },
    { id: 3, name: 'Mouser' },
    { id: 4, name: 'Arrow Electronics' },
    { id: 5, name: 'FDH Electronics' },
    { id: 6, name: 'Heilind Electronics' },
    { id: 7, name: 'Onlinecomponents.com' },
    { id: 8, name: 'RS (Formerly Allied Electronics)' },
    { id: 9, name: 'TTI' },
    { id: 10, name: 'TME' },
    { id: 11, name: 'Future Electronics' },
  ];
  parts: any;
  userId!: string | null;
  role!: string | null;
  openStatusCount!: number;
  overdueCount!: number;
  allOpenProjectDetails: any[] = [];
  allCustomerDetails: any;

  sourcingDummyData = [
    {
      "Customer Part No.": "461500500155",
      "Internal Part No.": "461500500155",
      "Description": "CON CIRS THD PL ST M3/22A SLD",
      "Specification": "MS3106F10SL-3P/TB3106FW-10SL-3PNC",
      "Commodity": "Connectors",
      "Manufacturer(Mfg)": "AMPHENOL AEROSPACE/ALLIED ELECTRONICS CORPORATION/TURBO INDIA INTERCONNECT",
      "UOM": "EA",
      "Project qty": 12.0,
      "I Sourcing": "Yes"
    },
  ];

  avdDummyData = [
    {
      "Internal Part No.": "461517560515",
      "Manufacturer(Mfg)": "ODU GMBH & CO. KG",
      "Specification": "G80YAR-P04WFG0-000L"
    }
  ];
  version_id: any;
  selectedProjectId: any;
  selectedVersionId: any = null;
  selectedEngineerData: any = null; // Store full engineer/project data to access procurement_version_id
  finalCompareDataList: any[] = [];
  selectedProjectName: string = '';
  isFetchingReleaseList: boolean = false;
  isExtractingHistory: boolean = false;
  showProjectDropdown: boolean = false;
  filteredProjectNames: string[] = [];
  filteredSourceListData: any[] = [];
  paginatedData: any[] = []; // Subset to show in table
  rowsPerPage: any = 10; // Default rows per page
  pageSizeOptions: any[] = [10, 20, 50, 100]; // Dropdown options
  totalProjectsCount: number = 0;
  costingTotalCount: number = 0;
  procurementTotalCount: number = 0;
  jumpPageInput: string = '';
  // totalPages: any;
  created_by_id!: number;
  selectedRowProjectId!: number;
  projectRowDetailsWithVersionId: any;
  socket!: WebSocket;
  isUploading = false;
  isRefresh = false; // Show refresh loader
  uploadedHeaders: string[] = [];
  fieldMapping: any = {};
  reverseFieldMapping: any = {};
  sourcingRawData: any[] = [];
  headerErrorMessage: string = '';
  isHeaderMappingRequired: boolean = false;
  expectedFields = [
    { key: 'customerPartNumber', label: 'Customer Part No.' },
    { key: 'internalPartNo', label: 'Internal Part No.' },
    { key: 'description', label: 'Description' },
    { key: 'specification', label: 'Specification' },
    { key: 'commodity', label: 'Commodity' },
    { key: 'manufacturer', label: 'Manufacturer(Mfg)' },
    { key: 'uom', label: 'UOM' },
    { key: 'projectQty', label: 'Project qty' },
    { key: 'eol_status', label: 'EOL Status' },
    { key: 'eol_confidence', label: 'EOL Confidence' },
    { key: 'iSourcing', label: 'I-Sourcing' }
  ];

  // AVD list mapping state
  uploadedAvdHeaders: string[] = [];
  reverseAvdFieldMapping: any = {};
  avdRawData: any[] = [];
  avdHeaderErrorMessage: string = '';
  isAvdHeaderMappingRequired: boolean = false;
  avdExpectedFields = [
    { key: 'internalPartNo', label: 'Internal Part No.' },
    { key: 'manufacturer', label: 'Manufacturer(Mfg)' },
    { key: 'specification', label: 'Specification' }
  ];

  applyMappedData() {
    this.sourceListData = [];
    const rawData = (this.sourcingRawData && this.sourcingRawData.length > 0) ? this.sourcingRawData : (Array.isArray(this.data) ? this.data : []);

    for (let i = 0; i < rawData.length; i++) {
      let rowO: any = rawData[i];
      let mappedRow: any = {};

      this.tableHeaders.forEach(header => {
        const uploadedHeader: any = this.reverseFieldMapping[header.key];

        if (uploadedHeader) {
          let val: any = rowO[uploadedHeader];

          if (header.key === 'projectQty') {
            // if no value, keep undefined instead of 0
            mappedRow[header.key] = val !== undefined && val !== null && val !== ''
              ? Number(val)
              : undefined;
          } else if (header.key === 'specification') {
            mappedRow[header.key] = val !== undefined && val !== null && val !== ''
              ? String(val).trim().replace(/\s+/g, '')
              : undefined;
          } else {
            // keep undefined if nothing mapped
            mappedRow[header.key] = val !== undefined && val !== null && val !== ''
              ? String(val).trim()
              : undefined;
          }
        } else {
          // dropdown not selected → undefined
          mappedRow[header.key] = "Undefined";
        }
      });

      this.sourceListData.push(mappedRow);
    }

    // Check if required headers are mapped, if so clear error message
    const optionalHeaders = ['I Sourcing', 'SlNo', 'eol_status', 'eol_confidence'];
    const requiredExpected = this.expectedFields.filter(f => !optionalHeaders.includes(f.label) && !optionalHeaders.includes(f.key));
    const missingKeys = requiredExpected.filter(f => !this.reverseFieldMapping[f.key]);

    if (missingKeys.length === 0) {
      this.headerErrorMessage = '';
      this.isHeaderMappingRequired = false;
    } else {
      const displayMissing = missingKeys.map(f => f.label);
      this.headerErrorMessage = 'Missing headers: ' + displayMissing.join(', ');
      this.isHeaderMappingRequired = true;
    }

    if (this.avdData.length === 0) {
      this.finalDataList = this.sourceListData;
    }

    this.fetchAllManufacturerMatches();
    this.cdRef.detectChanges();
    console.log(" Final Mapped Data:", this.sourceListData);
  }





  saveModal() {
    console.log('Selected Criteria:', this.criteria);

    this.finalDataList = this.finalDataList.map((item: any) => ({
      ...item, // Copy existing properties
      stockAvailability: Number(this.criteria.stockAvailability) >= 0 ? Number(this.criteria.stockAvailability) : 0,
      leadTime: this.criteria.leadTime ? 1 : 0,
      minimumPrice: Number(this.criteria.minimumPrice) >= 0 ? Number(this.criteria.minimumPrice) : 0,
      authorisedSuppliers: this.criteria.authorisedSuppliers ? 1 : 0,

      // suppliers: [
      //   'supplierName': (this.criteria.selectedSuppliers) ? (this.criteria.selectedSuppliers) : [],        
      // ],
      suppliers: this.criteria.selectedSuppliers
        ? this.criteria.selectedSuppliers.map(supplier => ({
          supplierName: supplier,
        }))
        : [],


    }));

    // alert('Criteria saved successfully!');
    console.log('finalDataList', this.finalDataList);
    setTimeout(() => {
      this.closeModal();
    }, 100)
  }


  toggleDatePicker() {
    this.isDatePickerOpen = !this.isDatePickerOpen;
  }
  isDatePickerOpen = false;
  displayDate(): string {
    if (this.fromDate && this.toDate) {
      return `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day} to ${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`;
    } else if (this.fromDate) {
      return `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`;
    }
    return '';
  }


  allCustomerData: any[] = [];
  addtionalChargesDetails = [];
  downloadData = [];
  closeResult: string = '';
  incorUploadFiles: any[] = [];
  selectedIncorFile: any;
  data: any;
  dataProp: string[] = [];
  sourceListData: any = [];
  avdData: any = [];
  sourcingListFileName: string = '';
  upload_input: any;
  alternatePartFileName: string = '';
  upload_avd_input: any;
  progressPercentage: string = '0';


  tableHeaders = [
    { key: "SlNo", label: "Sl No." },
    { key: "customerPartNumber", label: "Customer Part Number" },
    { key: "internalPartNo", label: "Internal Part Number" },
    { key: "description", label: "Description" },
    { key: "specification", label: "Specification" },
    { key: "commodity", label: "Commodity" },
    { key: "manufacturer", label: "Manufacturer(Mfg)" },
    { key: "uom", label: "UOM" },
    { key: "projectQty", label: "Project Quantity" },
    { key: "eol_status", label: "EOL Status" },
    { key: "eol_confidence", label: "EOL Confidence" },
    { key: "iSourcing", label: "I-Sourcing" }
  ];


  showSearch = false;
  showSearchRow: boolean[] = new Array(this.tableHeaders.length).fill(false); // Track column visibility
  searchValues: string[] = new Array(this.tableHeaders.length).fill(""); // Holds search input values

  // Completion category filter from source-pulse
  completionCategoryFilter: string | null = null;
  completionCategoryLabel: string | null = null;
  isCompletionFiltered: boolean = false;

  // Flag to indicate coming from source-pulse
  fromSourcePulse: boolean = false;


  constructor(private f_builder: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private masterService: MasterService,
    private notify: NbToastrService,
    private exportService: ExportService,
    private menuService: MenuService,
    private cdRef: ChangeDetectorRef
  ) {

  }

  loadProjectStatuses(): void {
    this.masterService.getProjectStatuses().subscribe({
      next: (res: any) => {
        if (res && res.data) {
          this.projectStatuses = res.data;
        }
      },
      error: (err: any) => {
        console.error('Error loading project statuses:', err);
      }
    });
  }

  ngOnInit(): void {
    this.loadProjectStatuses();
    this.userId = '';
    this.role = ''
    this.form = this.f_builder.group({
      source_file_name: [''],
      sourcingListFileName: [''],
      alternatePartFileName: [''],

    });
    this.userId = sessionStorage.getItem('user_id'); // Retrieves session user_id
    this.role = sessionStorage.getItem('role');     // Retrieves role    
    this.resolveManagerId();

    // Check if coming from source-pulse or project-view
    const navigationState = history.state;
    if (navigationState?.fromSourcePulse) {
      this.fromSourcePulse = true;
      console.log("📍 Arrived from Source Pulse");
    }

    this.projectForm = this.f_builder.group({
      newProjectName: ['', Validators.required],
      projectNo: [''],
      description: [''],
      customerFullName: ['', Validators.required],
      rfqDate: ['', Validators.required],
      completionDate: ['', Validators.required],
      targetLT: ['', Validators.required],
      assignTo: ['', Validators.required],
      currentStage: ['', Validators.required],
      version_id: [{ value: 1, disabled: true }, Validators.required]
    });

    this.customerForm = this.f_builder.group({
      _customerFullName: ['', [Validators.required, Validators.minLength(2)]],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      gstNumber: ['', [Validators.required]],
    });

    const currentDate = new Date();
    const istDate = new Date(currentDate.getTime() + (5.5 * 60 * 60 * 1000));
    this.maxToday = istDate.toISOString().split('T')[0];
    const nextDay = new Date(istDate);
    nextDay.setUTCDate(nextDay.getUTCDate() + 1);
    this.nextMaxDate = nextDay.toISOString().split('T')[0];
    this.currentDate = this.maxToday;
    this.assignDate = this.maxToday;

    this.projectForm.get('currentStage')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(newStage => {
      if (this.previousStage === 'Costing' && newStage === 'Procurement') {
        console.log("Stage changed: Costing -> Procurement");
        this.keepLandingCostValues();
      }
    });

    this.getEngineersData();

    this.getAllcustomers();
    this.fetchStageCounts();

    // ✅ FIX: Always load BOTH stages regardless of navigation state
    // This ensures tab switching works after returning from project-view
    if (navigationState?.activeTab) {
      // Coming from project-view - set the tab AFTER data loads
      console.log(`🔄 Returning from project-view - Will restore tab ${navigationState.activeTab} after loading data`);
      this.loadBothStages(() => {
        // After both stages are loaded, restore the navigation state
        this.restoreNavigationState(navigationState);
      });
    } else {
      // Normal initialization - load both stages
      this.loadBothStages();
    }
  }

  resolveManagerId(): void {
    const userDetailsStr = sessionStorage.getItem('userDetails');
    if (userDetailsStr) {
      try {
        const ud = JSON.parse(userDetailsStr);
        if (ud?.manager_id && !isNaN(Number(ud.manager_id))) {
          this.managerId = Number(ud.manager_id);
          sessionStorage.setItem('manager_id', String(this.managerId));
          console.log('✅ Resolved engineer manager_id from userDetails:', this.managerId);
          return;
        }
      } catch (e) {
        console.error('Error parsing userDetails in resolveManagerId:', e);
      }
    }

    const sessMgr = sessionStorage.getItem('manager_id');
    if (sessMgr && !isNaN(Number(sessMgr))) {
      this.managerId = Number(sessMgr);
      console.log('✅ Resolved engineer manager_id from sessionStorage:', this.managerId);
      return;
    }

    // Fallback: Query manage_users to fetch current user's manager_id
    if (this.userId) {
      this.masterService.add_user({ action: 'SELECT' }).subscribe({
        next: (res: any) => {
          const users = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
          const matched = users.find((u: any) => Number(u.user_id) === Number(this.userId));
          if (matched?.manager_id && !isNaN(Number(matched.manager_id))) {
            this.managerId = Number(matched.manager_id);
            sessionStorage.setItem('manager_id', String(this.managerId));
            console.log('✅ Resolved engineer manager_id from manage_users API:', this.managerId);
          }
        },
        error: (err: any) => console.warn('Could not resolve manager_id from manage_users API:', err)
      });
    }
  }

  getEngineersData(): void {
    this.masterService.engineers().pipe(
      catchError(() => {
        const mgrId = this.managerId || Number(sessionStorage.getItem('manager_id')) || Number(this.userId) || 1;
        const manager_id = { manager_id: mgrId };
        return this.masterService.get_manager_and_engineers(manager_id);
      })
    ).subscribe({
      next: (result: any) => {
        let list: any[] = [];
        if (Array.isArray(result)) {
          list = result;
        } else if (Array.isArray(result?.data)) {
          list = result.data;
        } else if (Array.isArray(result?.engineers)) {
          list = result.engineers;
        }
        this.engineersData = list;
        this.ensureCurrentEngineerInList();
      },
      error: () => {
        this.ensureCurrentEngineerInList();
      }
    });
  }

  ensureCurrentEngineerInList(): void {
    if (this.userId) {
      const uId = Number(this.userId);
      const exists = this.engineersData.some((e: any) => e.engineer_id === uId);
      if (!exists) {
        const uName = sessionStorage.getItem('username') || sessionStorage.getItem('user_name') || 'Current Engineer';
        this.engineersData = [...this.engineersData, { engineer_id: uId, engineer_name: uName }];
      }
    }
  }
  receiveData() {
    let receiveData: any = history.state
    console.log('receiveData => ', receiveData, receiveData?.currentPage)
    if (receiveData) {
      if (receiveData.hasOwnProperty('rowsPerPage')) {
        this.rowsPerPage = !!receiveData ? receiveData.rowsPerPage : 10
      }
      if (receiveData.hasOwnProperty('currentPage')) {
        this.currentPage = !!receiveData ? receiveData.currentPage : 1
        this.paginate();
      }

    }
    history.replaceState({}, '')
  }

  today: Date = new Date();
  calculateAgeing(assignedDate: string, status: string, closedDate?: string): number {
    const assignedDateObj = new Date(assignedDate);
    let endDate: Date;

    if (status === 'Closed' && closedDate) {
      endDate = new Date(closedDate);
    } else {
      endDate = new Date();
    }

    const timeDifference = endDate.getTime() - assignedDateObj.getTime();
    return Math.floor(timeDifference / (1000 * 3600 * 24));
  }
  openHeaderMappingModal(content: any) {
    this.modalService.open(content, { size: 'lg', backdrop: 'static' });
  }

  openAvdMappingModal(content: any) {
    this.modalService.open(content, { size: 'lg', backdrop: 'static' });
  }

  validateAvdHeaders() {
    this.avdHeaderErrorMessage = '';
    this.isAvdHeaderMappingRequired = false;

    if (!this.uploadedAvdHeaders || this.uploadedAvdHeaders.length === 0) {
      return;
    }

    const normalize = (str: string) => str ? str.toLowerCase().replace(/[^a-z0-9]/g, '').trim() : '';

    const avdExactAliases: { [key: string]: string[] } = {
      internalPartNo: ['internalpartno', 'internalpartnumber', 'internalpart', 'intpartno', 'intpn', 'internalpn', 'ipn', 'materialnumber', 'materialno', 'partnumber', 'partno'],
      manufacturer: ['manufacturermfg', 'manufacturer', 'mfg', 'mfr', 'brand', 'vendor', 'mfrname', 'mfrcode'],
      specification: ['specification', 'spec', 'partspecification', 'mfrref', 'mfrpartnumber', 'mpn', 'mfrpart', 'mfrcode']
    };

    this.reverseAvdFieldMapping = this.reverseAvdFieldMapping || {};
    this.avdExpectedFields.forEach(field => {
      const key = field.key;
      if (this.reverseAvdFieldMapping[key] && this.uploadedAvdHeaders.includes(this.reverseAvdFieldMapping[key])) {
        return;
      }

      const aliases = avdExactAliases[key] || [normalize(field.label), normalize(key)];
      const matchedHeader = this.uploadedAvdHeaders.find(h => {
        const normH = normalize(h);
        return aliases.includes(normH);
      });

      this.reverseAvdFieldMapping[key] = matchedHeader || null;
    });

    const requiredAvdKeys = ['internalPartNo', 'manufacturer', 'specification'];
    const missingAvdKeys = requiredAvdKeys.filter(k => !this.reverseAvdFieldMapping[k]);

    if (missingAvdKeys.length > 0) {
      const displayMissing = missingAvdKeys.map(k => {
        const found = this.avdExpectedFields.find(f => f.key === k);
        return found ? found.label : k;
      });
      this.avdHeaderErrorMessage = 'Missing AVD headers: ' + displayMissing.join(', ');
      this.isAvdHeaderMappingRequired = true;
    } else {
      this.avdHeaderErrorMessage = '';
      this.isAvdHeaderMappingRequired = false;
    }
  }

  applyAvdMappedData(showToast: boolean = true) {
    const rawData = (this.avdRawData && this.avdRawData.length > 0) ? this.avdRawData : [];
    if (!rawData || rawData.length === 0) {
      if (showToast) this.notify.warning('No AVD data available to map.');
      return;
    }

    this.avdData = [];
    for (let i = 0; i < rawData.length; i++) {
      const row = rawData[i];
      const intCol = this.reverseAvdFieldMapping['internalPartNo'];
      const mfgCol = this.reverseAvdFieldMapping['manufacturer'];
      const specCol = this.reverseAvdFieldMapping['specification'];

      const obj = {
        internalPartNo: String((intCol && row[intCol] !== undefined && row[intCol] !== null) ? row[intCol] : (row['Internal Part No.'] || row['Internal Part No'] || '')).trim(),
        manufacturer: String((mfgCol && row[mfgCol] !== undefined && row[mfgCol] !== null) ? row[mfgCol] : (row['Manufacturer(Mfg)'] || row['Manufacturer'] || '')).trim(),
        specification: String((specCol && row[specCol] !== undefined && row[specCol] !== null) ? row[specCol] : (row['Specification'] || row['Spec'] || '')).trim().replace(/\s+/g, ''),
      };
      this.avdData.push(obj);
    }

    const requiredAvdKeys = ['internalPartNo', 'manufacturer', 'specification'];
    const missingAvdKeys = requiredAvdKeys.filter(k => !this.reverseAvdFieldMapping[k]);
    if (missingAvdKeys.length === 0) {
      this.avdHeaderErrorMessage = '';
      this.isAvdHeaderMappingRequired = false;
    } else {
      const displayMissing = missingAvdKeys.map(k => {
        const found = this.avdExpectedFields.find(f => f.key === k);
        return found ? found.label : k;
      });
      this.avdHeaderErrorMessage = 'Missing AVD headers: ' + displayMissing.join(', ');
      this.isAvdHeaderMappingRequired = true;
    }

    if (this.sourceListData && this.sourceListData.length > 0) {
      this.combineSourcingAndAvd();
    } else {
      this.finalDataList = [...this.avdData];
      this.finalCompareDataList = [...this.finalDataList];
    }
    this.fetchAllManufacturerMatches();
    this.cdRef.detectChanges();
    if (showToast) {
      this.notify.success('AVD field mappings applied successfully');
    }
    console.log("Final AVD Mapped Data:", this.avdData);
  }
  isECDGreaterThanToday(dateString: string | Date): boolean {
    if (!dateString) return false;
    const today = new Date();
    const ecdDate = new Date(dateString);
    return ecdDate < today;
  }

  getProgressColor(progressValue: any): string {
    // Parse the progress value (handle both string with '%' and pure number)
    let progress = 0;
    if (typeof progressValue === 'string') {
      progress = parseInt(progressValue.replace('%', ''), 10);
    } else {
      progress = Number(progressValue);
    }

    // Return light/pastel color based on progress range
    if (progress >= 0 && progress < 50) {
      return '#FFCDD2'; // Light Red/Pink
    } else if (progress >= 50 && progress < 75) {
      return '#FFF9C4'; // Light Yellow
    } else if (progress >= 75 && progress <= 100) {
      return '#C8E6C9'; // Light Green
    }
    return '#E0F2F1'; // Default light color
  }

  filterProjectNames() {
    const input = (this.selectedProjectName || '').toLowerCase().trim();
    if (input) {
      this.filteredProjectNames = this.projectNameDetails.filter(name =>
        name && name.toLowerCase().includes(input)
      );
    } else {
      this.filteredProjectNames = [...this.projectNameDetails];
    }
    this.showProjectDropdown = true;
    this.applyFilters();
  }

  selectProjectName(name: string) {
    this.selectedProjectName = name;
    this.showProjectDropdown = false;
    this.applyFilters();
  }

  onProjectFocus() {
    this.showProjectDropdown = true;
    const input = (this.selectedProjectName || '').toLowerCase().trim();
    if (input) {
      this.filteredProjectNames = this.projectNameDetails.filter(name =>
        name && name.toLowerCase().includes(input)
      );
    } else {
      this.filteredProjectNames = [...this.projectNameDetails];
    }
  }

  onProjectEnter() {
    this.showProjectDropdown = false;
    this.applyFilters();
  }

  hideDropdown() {
    setTimeout(() => {
      this.showProjectDropdown = false;
    }, 250);
  }

  getThisMonthProjects() {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    this.thisMonthProjects = this.matchedCustomerData.filter(group => {
      const rfqDate = new Date(group.rfqDate);
      return rfqDate.getMonth() === currentMonth && rfqDate.getFullYear() === currentYear;
    });

    console.log("This Month Projects:", this.thisMonthProjects);
  }

  onThisMonthClick() {
    this.statusFilter = this.statusFilter === 'ThisMonth' ? null : 'ThisMonth';
    this.applyFilters();
  }





  // Update table rows per page
  updateTableRows() {
    // With grouped data, versions array already exists in each group
    console.log('this.matchedCustomerData', this.matchedCustomerData)

    if (String(this.rowsPerPage) === 'All') {
      this.paginatedData = [...this.matchedCustomerData];
      console.log('paginatedData => ', this.paginatedData)
      // this.totalPages = 1;
    } else {
      // this.totalPages = Math.ceil(this.matchedCustomerData.length / this.rowsPerPage);
      this.currentPage = 1; // Reset to first page
      console.log('reset current page to 1 => ', this.currentPage)
      this.paginate();
      this.receiveData();
    }
  }
  updateCardCounts(): void {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dataToCount = this.getBaseProjectsForActiveTab();

    this.openStatusCount = dataToCount.filter(item => item.status === 'Open').length;

    this.overdueCount = dataToCount.filter(item => {
      // expectedCompletionDate lives inside selectedVersionData for grouped data
      const ecd = item.selectedVersionData?.expectedCompletionDate || item.expectedCompletionDate;
      if (!ecd) return false;
      const expectedDate = new Date(ecd);
      expectedDate.setHours(0, 0, 0, 0);
      return expectedDate < today && item.status === 'Open';
    }).length;

    this.thisMonthProjects = dataToCount.filter(item => {
      const rfqVal = item.rfqDate || item.selectedVersionData?.expectedCompletionDate || item.expectedCompletionDate;
      if (!rfqVal) return false;
      const expectedDate = new Date(rfqVal);
      return expectedDate.getMonth() === today.getMonth() &&
        expectedDate.getFullYear() === today.getFullYear();
    });

    console.log(`📊 Stat Cards Updated for Tab ${this.activeTab} - Open: ${this.openStatusCount}, Overdue: ${this.overdueCount}, This Month: ${this.thisMonthProjects.length}`);
  }


  paginate() {
    let state: any = history.state
    console.log('state => ', state)
    const rows = String(this.rowsPerPage) === 'All' ? this.matchedCustomerData.length : Number(this.rowsPerPage);
    console.log("currentPage  =>", this.currentPage)
    let startIndex = (this.currentPage - 1) * rows;
    let endIndex = startIndex + rows;
    if (state.hasOwnProperty('startIndex') && state.hasOwnProperty('endIndex')
      && state.hasOwnProperty('currentPage') && state.hasOwnProperty('rowsPerPage')) {
      startIndex = state.startIndex;
      endIndex = state.endIndex;
      this.currentPage = state.currentPage ?? 1;
      this.rowsPerPage = state.rowsPerPage ?? 10;
      history.replaceState({}, '');
    }
    this.paginatestartIndex = startIndex;
    this.paginateendIndex = endIndex;
    console.log("rows => ", rows, "startIndex=>", startIndex, "endIndex=>", endIndex, "currentPage=>", this.currentPage)

    this.paginatedData = this.matchedCustomerData.slice(startIndex, endIndex);

    console.log('paginatedData', this.paginatedData)
  }

  syncCurrentPageToActiveTab(): void {
    if (this.activeTab === 1) {
      this.costingCurrentPage = this.currentPage;
      this.costingRowsPerPage = this.rowsPerPage;
    } else {
      this.procurementCurrentPage = this.currentPage;
      this.procurementRowsPerPage = this.rowsPerPage;
    }
  }

  nextPage() {
    if (this.currentPage < this.getTotalPagesForTab()) {
      this.currentPage++;
      this.syncCurrentPageToActiveTab();
      if (this.isAnyFilterActive()) {
        this.paginateFilteredData();
      } else {
        const stage = this.activeTab === 1 ? 'costing' : 'procurement';
        this.getAllOpenProjectData(stage);
      }
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.syncCurrentPageToActiveTab();
      if (this.isAnyFilterActive()) {
        this.paginateFilteredData();
      } else {
        const stage = this.activeTab === 1 ? 'costing' : 'procurement';
        this.getAllOpenProjectData(stage);
      }
    }
  }

  firstPage() {
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.syncCurrentPageToActiveTab();
      if (this.isAnyFilterActive()) {
        this.paginateFilteredData();
      } else {
        const stage = this.activeTab === 1 ? 'costing' : 'procurement';
        this.getAllOpenProjectData(stage);
      }
    }
  }

  lastPage() {
    const total = this.getTotalPagesForTab();
    if (this.currentPage < total && total > 0) {
      this.currentPage = total;
      this.syncCurrentPageToActiveTab();
      if (this.isAnyFilterActive()) {
        this.paginateFilteredData();
      } else {
        const stage = this.activeTab === 1 ? 'costing' : 'procurement';
        this.getAllOpenProjectData(stage);
      }
    }
  }

  goToPage(page: number | string): void {
    const pageNum = Number(page);
    const totalPages = this.getTotalPagesForTab();
    if (!isNaN(pageNum) && pageNum >= 1 && (totalPages <= 0 || pageNum <= totalPages) && pageNum !== this.currentPage) {
      this.currentPage = pageNum;
      this.syncCurrentPageToActiveTab();
      if (this.isAnyFilterActive()) {
        this.paginateFilteredData();
      } else {
        const stage = this.activeTab === 1 ? 'costing' : 'procurement';
        this.getAllOpenProjectData(stage);
      }
    }
  }

  jumpToPage(customVal?: string): void {
    const val = customVal !== undefined ? customVal : this.jumpPageInput;
    const page = parseInt(String(val).trim(), 10);
    const totalPages = this.getTotalPagesForTab();
    if (!isNaN(page)) {
      let targetPage = page;
      if (targetPage < 1) targetPage = 1;
      if (totalPages > 0 && targetPage > totalPages) targetPage = totalPages;
      this.jumpPageInput = '';
      this.goToPage(targetPage);
    }
  }

  jumpByPages(direction: number): void {
    const totalPages = this.getTotalPagesForTab();
    let targetPage = this.currentPage + direction;
    if (targetPage < 1) targetPage = 1;
    if (totalPages > 0 && targetPage > totalPages) targetPage = totalPages;
    if (targetPage !== this.currentPage) {
      this.goToPage(targetPage);
    }
  }

  onPageSizeChange(): void {
    this.currentPage = 1;
    this.syncCurrentPageToActiveTab();
    if (this.isAnyFilterActive()) {
      this.paginateFilteredData();
    } else {
      const stage = this.activeTab === 1 ? 'costing' : 'procurement';
      this.getAllOpenProjectData(stage);
    }
  }

  get totalPages(): number {
    return this.getTotalPagesForTab();
  }

  get startIndex(): number {
    return this.getStartIndexForTab();
  }

  get endIndex(): number {
    return this.getEndIndexForTab();
  }

  trackByCustomer(index: number, customer: any): string {
    return `${customer.projectName}-${customer.customer_name}-${customer.version_id}-${customer.upload_status}`;
  }


  refreshPage() {
    this.isRefresh = true; // Show loader

    // Preserve the current active tab before reset
    const currentTab = this.activeTab;

    // Reset all tab and pagination states to initial values
    this.resetTabsAndPagination();

    // Restore the active tab
    this.activeTab = currentTab;

    // Reset all filters
    this.resetAllFilters();

    // Reset completion category filter
    this.completionCategoryFilter = null;
    this.completionCategoryLabel = null;
    this.isCompletionFiltered = false;

    // Reset upload data
    this.resetFinalData();

    // Reload data from APIs with the correct stage
    const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
    this.getAllcustomers();
    this.fetchStageCounts();
    this.getAllOpenProjectData(currentStage);
  }

  // Reset tabs and pagination to initial state
  private resetTabsAndPagination(): void {
    // Tab state
    this.activeTab = 1; // Default to Costing tab

    // Tab-specific pagination
    this.costingCurrentPage = 1;
    this.procurementCurrentPage = 1;
    this.costingRowsPerPage = 10;
    this.procurementRowsPerPage = 10;
    this.costingTotalCount = 0;
    this.procurementTotalCount = 0;

    // General pagination
    this.currentPage = 1;
    this.rowsPerPage = 10;
    this.totalProjectsCount = 0;
    this.paginatestartIndex = 0;
    this.paginateendIndex = 10;

    // Tab data
    this.costingData = [];
    this.procurementData = [];
    this.currentTabData = [];
    this.paginatedData = [];

    // State persistence
    this.highlightedProjectId = null;
    this.restoredState = false;

    console.log('✅ Tabs and pagination reset to initial state');
  }

  // Reset all filter values
  private resetAllFilters(): void {
    this.selectedProjectName = '';
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    this.selectedRfqDate = '';
    this.fromExpectedCompletionDate = '';
    this.toExpectedCompletionDate = '';
    this.fromRfqDate = '';
    this.toRfqDate = '';
    this.statusFilter = null;
    this.completionCategoryFilter = null;
    this.completionCategoryLabel = null;
    this.isCompletionFiltered = false;
    this.showProjectDropdown = false;
    this.filteredProjectNames = [];

    console.log('✅ All filters reset to initial state');
  }

  toggleSearch(index: number) {
    this.showSearch = true; // Show search row
    this.showSearchRow[index] = !this.showSearchRow[index]; // Toggle visibility for clicked column
  }


  filterData() {
    const hasSearch = this.searchValues.some(val => val && val.trim() !== '');

    if (hasSearch) {
      const filtered = this.finalCompareDataList.filter(item =>
        this.tableHeaders.every((col, i) => {
          const searchValue = this.searchValues[i]?.toLowerCase().trim();
          if (!searchValue) return true;
          const itemValue = item[col.key]?.toString().toLowerCase();
          return itemValue?.includes(searchValue);
        })
      );

      if (filtered.length > 0) {
        this.finalDataList = filtered;
      }
    } else {

      this.finalDataList = [...this.finalCompareDataList];
    }
  }


  getAllcustomers(callback?: () => void) {
    let cus = {
      "operation_type": "READALL"
    };
    this.masterService.all_customers(cus).subscribe({
      next: (result: any) => {
        let list: any[] = [];
        if (Array.isArray(result)) {
          list = result;
        } else if (Array.isArray(result?.data)) {
          list = result.data;
        } else if (Array.isArray(result?.record)) {
          list = result.record;
        } else if (Array.isArray(result?.customers)) {
          list = result.customers;
        }

        this.syncCustomerDropdown(list);
        console.log('allCustomerData updated:', this.allCustomerData);
        if (callback) {
          callback();
        }
        this.cdRef.detectChanges();
      },
      error: (err: any) => {
        console.error('Error: Unable to retrieve customer data', err);
        this.syncCustomerDropdown([]);
        if (callback) {
          callback();
        }
        this.cdRef.detectChanges();
      }
    });
  }

  syncCustomerDropdown(apiCustomers: any[] = []): void {
    const customerMap = new Map<string, any>();

    (apiCustomers || []).forEach(item => {
      const name = item?.customerName || item?.customer_name || item?.['Customer Full name'] || (typeof item === 'string' ? item : '');
      const id = item?.customer_id ?? item?.id ?? null;
      if (name && typeof name === 'string' && name.trim() && name.trim() !== 'N/A') {
        const trimmed = name.trim();
        const key = trimmed.toLowerCase();
        if (!customerMap.has(key)) {
          customerMap.set(key, {
            customerName: trimmed,
            customer_name: trimmed,
            customer_id: id ? Number(id) : null,
            id: id ? Number(id) : null
          });
        } else if (id && !customerMap.get(key).customer_id) {
          customerMap.get(key).customer_id = Number(id);
          customerMap.get(key).id = Number(id);
        }
      }
    });

    const allProjects = [
      ...(this.allCostingProjects || []),
      ...(this.allProcurementProjects || []),
      ...(this.costingData || []),
      ...(this.procurementData || []),
      ...(this.allOpenProjectDetails || [])
    ];

    allProjects.forEach(p => {
      const cName = p?.customer_name || p?.customerName;
      const cId = p?.customer_id || null;
      if (cName && typeof cName === 'string' && cName.trim() && cName.trim() !== 'N/A') {
        const trimmed = cName.trim();
        const key = trimmed.toLowerCase();
        if (!customerMap.has(key)) {
          customerMap.set(key, {
            customerName: trimmed,
            customer_name: trimmed,
            customer_id: cId ? Number(cId) : null,
            id: cId ? Number(cId) : null
          });
        } else if (cId && !customerMap.get(key).customer_id) {
          customerMap.get(key).customer_id = Number(cId);
          customerMap.get(key).id = Number(cId);
        }
      }
    });

    const mergedList = Array.from(customerMap.values())
      .sort((a, b) => a.customerName.localeCompare(b.customerName));

    this.allCustomerData = mergedList;
    this.allCustomerDetails = mergedList;
  }

  syncProjectNameDetails(): void {
    const allProjects = [
      ...(this.allCostingProjects || []),
      ...(this.allProcurementProjects || []),
      ...(this.costingData || []),
      ...(this.procurementData || []),
      ...(this.allOpenProjectDetails || [])
    ];
    const names = new Set<string>();
    allProjects.forEach(p => {
      const name = p?.projectName || p?.project_name;
      if (name && typeof name === 'string' && name.trim()) {
        names.add(name.trim());
      }
    });
    this.projectNameDetails = Array.from(names).sort((a, b) => a.localeCompare(b));
    if (!this.selectedProjectName) {
      this.filteredProjectNames = [...this.projectNameDetails];
    }
  }

  loading = true;

  // Group projects by ID and current stage, keeping all versions in versionDetails
  groupProjectsByStageAndVersion(data: any[]): any[] {
    const groupMap = new Map();

    data.forEach(customer => {
      // Create a unique key combining project_id and currentstage
      const groupKey = `${customer.project_id}_${customer.currentstage}`;

      if (!groupMap.has(groupKey)) {
        // First occurrence of this project + stage combination
        const processedProgress = customer.upload_status?.toLowerCase() === 'new' || customer.upload_status?.toLowerCase() === 'inprogress' ? '0%' : customer.progress;

        groupMap.set(groupKey, {
          // Group-level data (project info)
          project_id: customer.project_id,
          projectName: customer.projectName,
          customer_name: customer.customer_name || customer.customerName || 'N/A',
          customerName: customer.customerName || customer.customer_name || 'N/A',
          rfqDate: customer.rfqDate,
          assigned_to_id: customer.assigned_to_id,
          assigned_date: customer.assigned_date,
          targetLeadTime: customer.targetLeadTime,
          status: customer.status,
          closed_date: customer.closed_date,
          // Stage-specific data
          currentstage: customer.currentstage,

          // Version management for Costing tab - Use API arrays if available
          versions: customer.version_ids || [customer.version_id],
          versionDetails: [
            {
              ...customer,
              progress: processedProgress,
              version_id: customer.version_id
            }
          ],
          // Currently displayed version data - show the latest (first in array)
          selectedVersionData: {
            ...customer,
            progress: processedProgress,
            version_id: customer.version_id
          },

          // Version management for Procurement tab - Use API arrays if available (regardless of currentstage)
          procurementVersions: customer.procurement_version_ids || (customer.currentstage === 'Procurement' ? [customer.procurement_version_id || 0] : []),
          procurementVersionDetails: (customer.procurement_version_ids && customer.procurement_version_ids.length > 0) || customer.currentstage === 'Procurement' ? [
            {
              ...customer,
              progress: processedProgress,
              procurement_version_id: customer.procurement_version_id || 0
            }
          ] : [],
          // Currently displayed procurement version data - show the latest (first in array) if procurement versions exist
          selectedProcurementVersionData: (customer.procurement_version_ids && customer.procurement_version_ids.length > 0) || customer.currentstage === 'Procurement' ? {
            ...customer,
            progress: processedProgress,
            procurement_version_id: customer.procurement_version_id || 0
          } : null
        });
      } else {
        // Subsequent version of the same project + stage combination
        const group = groupMap.get(groupKey);
        const processedProgress = customer.upload_status?.toLowerCase() === 'new' || customer.upload_status?.toLowerCase() === 'inprogress' ? '0%' : customer.progress;

        if (customer.currentstage === 'Costing' || (customer.version_ids && customer.version_ids.length > 0)) {
          // Add version_id to versions array if not already present
          if (!group.versions.includes(customer.version_id)) {
            group.versions.push(customer.version_id);
          }
          // Add to versionDetails if not already present
          if (!group.versionDetails.find((v: any) => v.version_id === customer.version_id)) {
            group.versionDetails.push({
              ...customer,
              progress: processedProgress,
              version_id: customer.version_id
            });
          }
        } else if (customer.currentstage === 'Procurement' || (customer.procurement_version_ids && customer.procurement_version_ids.length > 0)) {
          // Add procurement_version_id to procurementVersions array if not already present
          const procVerId = customer.procurement_version_id || 0;
          if (!group.procurementVersions.includes(procVerId)) {
            group.procurementVersions.push(procVerId);
          }
          // Add to procurementVersionDetails if not already present
          if (!group.procurementVersionDetails.find((v: any) => v.procurement_version_id === procVerId)) {
            group.procurementVersionDetails.push({
              ...customer,
              progress: processedProgress,
              procurement_version_id: procVerId
            });
          }
        }
      }
    });

    // Sort versions descending (latest first) and set selectedVersionData to latest
    const groups = Array.from(groupMap.values());
    groups.forEach(group => {
      group.versions.sort((a: number, b: number) => b - a);
      group.procurementVersions.sort((a: number, b: number) => b - a);

      // Default selectedVersionData to the latest (highest) version
      if (group.versions.length > 0) {
        const latestVersionId = group.versions[0];
        const latestVersion = group.versionDetails.find((v: any) => v.version_id === latestVersionId);
        if (latestVersion) {
          group.selectedVersionData = { ...latestVersion };
        }
      }

      // Default selectedProcurementVersionData to the latest procurement version
      if (group.procurementVersions.length > 0) {
        const latestProcVersionId = group.procurementVersions[0];
        const latestProcVersion = group.procurementVersionDetails.find((v: any) => v.procurement_version_id === latestProcVersionId);
        if (latestProcVersion) {
          group.selectedProcurementVersionData = { ...latestProcVersion };
          group.selectedVersionData = { ...latestProcVersion };
        }
      }
    });

    return groups;
  }

  getAllOpenProjectData(currentStage: string = 'costing') {
    const isCosting = currentStage.toLowerCase() === 'costing';
    const limit = String(this.rowsPerPage) === 'All' ? 100000 : (Number(this.rowsPerPage) || 10);
    const offset = (Math.max(1, this.currentPage) - 1) * limit;

    let payloadData: any = {
      "action": "SELECT_PROJECTS",
      "assigned_to_id": Number(this.userId),
      "currentstage": currentStage,
      "limit": limit,
      "offset": offset
    };

    if (this.selectedProjectName && this.selectedProjectName.trim()) {
      payloadData.projectName = this.selectedProjectName.trim();
    }

    this.loading = true;
    console.log('manage_projects payload => ', payloadData);
    this.masterService.manage_projects(payloadData).subscribe({
      next: (result: any) => {
        console.log('manage_projects response => ', result);
        this.isRefresh = false;
        this.loading = false;

        if (result && result.data) {
          const rawData = Array.isArray(result.data) ? result.data : [];
          const totalFromApi = result.total_count ?? result.total ?? result.count ?? result.total_records ?? result.totalProjects ?? result.totalCount ?? result.pagination?.total_records ?? result.pagination?.total;

          // Group the data by project_id and currentstage
          this.matchedCustomerData = this.groupProjectsByStageAndVersion(rawData);
          console.log('✅ Grouped data:', this.matchedCustomerData);

          this.allOpenProjectDetails = [...this.matchedCustomerData];
          this.currentTabData = [...this.matchedCustomerData];
          this.paginatedData = [...this.matchedCustomerData];

          if (isCosting) {
            this.costingData = this.matchedCustomerData;
            if (!this.allCostingProjects || this.allCostingProjects.length === 0) {
              this.allCostingProjects = this.costingData;
            }
            if (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi))) {
              this.costingTotalCount = Number(totalFromApi);
            } else if (rawData.length < limit && rawData.length > 0) {
              this.costingTotalCount = offset + rawData.length;
            } else if (!this.costingTotalCount || this.costingTotalCount <= 0) {
              this.costingTotalCount = offset + rawData.length;
            }
            if (!this.isAnyFilterActive()) {
              this.totalProjectsCount = this.costingTotalCount;
            }
          } else {
            this.procurementData = this.matchedCustomerData;
            if (!this.allProcurementProjects || this.allProcurementProjects.length === 0) {
              this.allProcurementProjects = this.procurementData;
            }
            if (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi))) {
              this.procurementTotalCount = Number(totalFromApi);
            } else if (rawData.length < limit && rawData.length > 0) {
              this.procurementTotalCount = offset + rawData.length;
            } else if (!this.procurementTotalCount || this.procurementTotalCount <= 0) {
              this.procurementTotalCount = offset + rawData.length;
            }
            if (!this.isAnyFilterActive()) {
              this.totalProjectsCount = this.procurementTotalCount;
            }
          }

          this.overdueCount = this.getOverdueItems(this.matchedCustomerData).length;
          this.openStatusCount = this.matchedCustomerData.filter(item =>
            item.status === 'Open' || item.status === 'In Progress'
          ).length;

          this.syncProjectNameDetails();
          this.syncCustomerDropdown(this.allCustomerDetails || []);
          console.log('projectNameDetails', this.projectNameDetails);

          this.updateCardCounts();
          this.getThisMonthProjects();

          // Check if navigating from source-pulse or project-view
          const navigationState = history.state;
          if (navigationState?.activeTab && !this.restoredState) {
            console.log('🔄 Restoring navigation state from Project View');
            this.restoreNavigationState(navigationState);
            history.replaceState({}, '');
          }
        } else {
          this.matchedCustomerData = [];
          this.allOpenProjectDetails = [];
          this.currentTabData = [];
          this.paginatedData = [];
          if (isCosting) {
            this.costingTotalCount = 0;
            this.totalProjectsCount = 0;
          } else {
            this.procurementTotalCount = 0;
            this.totalProjectsCount = 0;
          }
        }
      },
      error: (err: any) => {
        this.isRefresh = false;
        this.loading = false;
        console.error('Error: Unable to retrieve project data', err);
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }
    });
  }

  fetchStageCounts(): void {
    const costingPayload = {
      action: "SELECT_PROJECTS",
      assigned_to_id: Number(this.userId),
      currentstage: 'costing',
      limit: 100000,
      offset: 0
    };
    this.masterService.manage_projects(costingPayload).subscribe({
      next: (res: any) => {
        if (res?.data) {
          const rawCosting = Array.isArray(res.data) ? res.data : [];
          this.allCostingProjects = this.groupProjectsByStageAndVersion(rawCosting);
          const totalFromApi = res.total_count ?? res.total ?? res.count ?? res.total_records;
          this.costingTotalCount = (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi)))
            ? Number(totalFromApi)
            : this.allCostingProjects.length;
          if (this.activeTab === 1 && !this.isAnyFilterActive()) {
            this.totalProjectsCount = this.costingTotalCount;
          }
          this.syncProjectNameDetails();
          this.syncCustomerDropdown(this.allCustomerDetails || []);
          this.updateCardCounts();
          console.log('📊 Stage count loaded - Costing:', this.costingTotalCount, 'Grouped:', this.allCostingProjects.length);
        }
      },
      error: (err: any) => console.error('Error fetching costing count:', err)
    });

    const procurementPayload = {
      action: "SELECT_PROJECTS",
      assigned_to_id: Number(this.userId),
      currentstage: 'procurement',
      limit: 100000,
      offset: 0
    };
    this.masterService.manage_projects(procurementPayload).subscribe({
      next: (res: any) => {
        if (res?.data) {
          const rawProcurement = Array.isArray(res.data) ? res.data : [];
          this.allProcurementProjects = this.groupProjectsByStageAndVersion(rawProcurement);
          const totalFromApi = res.total_count ?? res.total ?? res.count ?? res.total_records;
          this.procurementTotalCount = (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi)))
            ? Number(totalFromApi)
            : this.allProcurementProjects.length;
          if (this.activeTab === 2 && !this.isAnyFilterActive()) {
            this.totalProjectsCount = this.procurementTotalCount;
          }
          this.syncProjectNameDetails();
          this.syncCustomerDropdown(this.allCustomerDetails || []);
          this.updateCardCounts();
          console.log('📊 Stage count loaded - Procurement:', this.procurementTotalCount, 'Grouped:', this.allProcurementProjects.length);
        }
      },
      error: (err: any) => console.error('Error fetching procurement count:', err)
    });
  }

  /**
   * Load both Costing and Procurement stage data during initial dashboard load
   * This ensures both tab counts are populated correctly on first load
   * @param onComplete Optional callback to execute after both stages are loaded
   */
  private loadBothStages(onComplete?: () => void): void {
    let costingGroupedData: any[] = [];
    let procurementGroupedData: any[] = [];
    let stagesLoaded = 0;

    // Helper function to handle individual stage completion
    const onStageComplete = () => {
      stagesLoaded++;
      // When both stages are loaded, merge and display
      if (stagesLoaded === 2) {
        if (this.activeTab === 1) {
          this.matchedCustomerData = costingGroupedData;
          this.currentTabData = costingGroupedData;
          this.paginatedData = costingGroupedData;
          this.currentPage = this.costingCurrentPage || 1;
          this.rowsPerPage = this.costingRowsPerPage || 10;
          this.totalProjectsCount = this.costingTotalCount;
        } else {
          this.matchedCustomerData = procurementGroupedData;
          this.currentTabData = procurementGroupedData;
          this.paginatedData = procurementGroupedData;
          this.currentPage = this.procurementCurrentPage || 1;
          this.rowsPerPage = this.procurementRowsPerPage || 10;
          this.totalProjectsCount = this.procurementTotalCount;
        }

        if (!this.allCostingProjects || this.allCostingProjects.length === 0) {
          this.allCostingProjects = costingGroupedData;
        }
        if (!this.allProcurementProjects || this.allProcurementProjects.length === 0) {
          this.allProcurementProjects = procurementGroupedData;
        }

        this.allOpenProjectDetails = [...this.matchedCustomerData];
        this.syncProjectNameDetails();
        this.syncCustomerDropdown(this.allCustomerDetails || []);
        this.updateCardCounts();

        console.log(`✅ Both stages loaded - Costing: ${costingGroupedData.length} (Total: ${this.costingTotalCount}), Procurement: ${procurementGroupedData.length} (Total: ${this.procurementTotalCount})`);
        console.log(`📊 Stat Cards - Open: ${this.openStatusCount}, Overdue: ${this.overdueCount}, This Month: ${this.thisMonthProjects?.length || 0}`);
        console.log(`📊 Tab Badges - Costing: ${this.costingTotalCount}, Procurement: ${this.procurementTotalCount}`);

        this.loading = false;
        this.isRefresh = false;

        if (onComplete) {
          console.log('🔄 Executing completion callback');
          onComplete();
        }
      }
    };

    // Trigger stage counts in parallel to ensure true total count is available upfront
    this.fetchStageCounts();

    // Load Costing Stage
    const costingLimit = Number(this.costingRowsPerPage) || 10;
    const costingOffset = (Math.max(1, this.costingCurrentPage) - 1) * costingLimit;
    let costingPayload: any = {
      "action": "SELECT_PROJECTS",
      "assigned_to_id": Number(this.userId),
      "currentstage": 'costing',
      "limit": costingLimit,
      "offset": costingOffset
    };

    this.masterService.manage_projects(costingPayload).subscribe({
      next: (result: any) => {
        if (result?.data) {
          costingGroupedData = this.groupProjectsByStageAndVersion(result.data);
          this.costingData = costingGroupedData;
          const totalFromApi = result.total_count ?? result.total ?? result.count ?? result.total_records ?? result.totalProjects ?? result.totalCount ?? result.pagination?.total_records ?? result.pagination?.total;
          if (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi))) {
            this.costingTotalCount = Number(totalFromApi);
          } else if (result.data.length < costingLimit) {
            this.costingTotalCount = costingOffset + result.data.length;
          } else if (!this.costingTotalCount || this.costingTotalCount <= 0) {
            this.costingTotalCount = costingOffset + result.data.length;
          }
          console.log('✅ Costing data loaded:', costingGroupedData.length, 'projects, Total count:', this.costingTotalCount);
        }
        onStageComplete();
      },
      error: (error) => {
        console.error('❌ Error loading costing data:', error);
        onStageComplete();
      }
    });

    // Load Procurement Stage
    const procurementLimit = Number(this.procurementRowsPerPage) || 10;
    const procurementOffset = (Math.max(1, this.procurementCurrentPage) - 1) * procurementLimit;
    let procurementPayload: any = {
      "action": "SELECT_PROJECTS",
      "assigned_to_id": Number(this.userId),
      "currentstage": 'procurement',
      "limit": procurementLimit,
      "offset": procurementOffset
    };

    this.masterService.manage_projects(procurementPayload).subscribe({
      next: (result: any) => {
        if (result?.data) {
          procurementGroupedData = this.groupProjectsByStageAndVersion(result.data);
          this.procurementData = procurementGroupedData;
          const totalFromApi = result.total_count ?? result.total ?? result.count ?? result.total_records ?? result.totalProjects ?? result.totalCount ?? result.pagination?.total_records ?? result.pagination?.total;
          if (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi))) {
            this.procurementTotalCount = Number(totalFromApi);
          } else if (result.data.length < procurementLimit) {
            this.procurementTotalCount = procurementOffset + result.data.length;
          } else if (!this.procurementTotalCount || this.procurementTotalCount <= 0) {
            this.procurementTotalCount = procurementOffset + result.data.length;
          }
          console.log('✅ Procurement data loaded:', procurementGroupedData.length, 'projects, Total count:', this.procurementTotalCount);
        }
        onStageComplete();
      },
      error: (error) => {
        console.error('❌ Error loading procurement data:', error);
        onStageComplete();
      }
    });

    this.loading = true;
  }

  selectedCustomer: any;
  isRestrictedStatus(statusName: any): boolean {
    const status = (statusName || '').toLowerCase().trim();
    return status === 'pending - manager review' || status === 'approved';
  }

  openVersionChoicePopup(modalRef: any, customer: any) {
    if (this.isRestrictedStatus(customer.approval_status)) {
      this.notify.warning("Creation of new version is not allowed when the project is in the review or approved stage.");
      return;
    }
    this.selectedCustomer = customer;
    this.modalService.open(modalRef, {
      centered: true,
      backdrop: 'static'
    });
  }
  chooseNewVersion() {
    if (this.selectedCustomer) {
      this.startAddingNewVersion(this.selectedCustomer);
    }
  }
  // chooseCloneVersion() {
  //   const versionData = this.selectedCustomer;

  //   if (!versionData) return;

  //   // Find the parent group to get versions array
  //   const group = this.matchedCustomerData.find(g => g.project_id === versionData.project_id);

  //   if (!group) {
  //     this.notify.danger('Project group not found.');
  //     return;
  //   }

  //   const lastVersion = group.versions.length > 0
  //     ? Math.max(...group.versions)
  //     : 0;

  //   const cloneVersion = lastVersion + 1;

  //   // Add to group versions and versionDetails
  //   group.versions.push(cloneVersion);
  //   group.versionDetails.push({
  //     ...versionData,
  //     version_id: cloneVersion
  //   });
  //   group.selectedVersionData = {
  //     ...versionData,
  //     version_id: cloneVersion
  //   };

  //   this.notify.success(`Clone version ${cloneVersion} prepared`);
  //   this.modalService.dismissAll();
  // }


  isLowerVersion(versionData: any): boolean {
    // versionData is passed from selectedVersionData
    // Find the group this version belongs to
    const group = this.matchedCustomerData.find(g => g.projectName === versionData.projectName);

    if (!group || !group.versions || group.versions.length === 0) {
      return false;
    }

    const highestVersion = Math.max(...group.versions);
    return versionData.version_id < highestVersion;
  }

  fromDate: any;
  toDate: any;

  onDateSelection(date: any, type: string) {
    if (type === 'from') {
      this.fromDate = date;
    } else {
      this.toDate = date;
    }
  }

  calculateProgress(data: any[]): string {
    const totalRows = data.length;
    if (totalRows === 0) return '0';

    const validSupplierCount = data.filter(
      item => item.supplier && item.supplier !== 'N/A'
    ).length;

    const progress = (validSupplierCount / totalRows) * 100;
    return progress.toFixed(2);
  }


  onVersionChange(event: any, group: any) {
    console.log('🔍 Costing Version Change - group:', group);

    const selectedVersionId = Number(event.target.value);
    console.log(`📌 Selected version_id: ${selectedVersionId}`);
    console.log('📦 Available versionDetails:', group.versionDetails);

    // Find the matching version in versionDetails (which contains all version data from API)
    let selectedVersion = group.versionDetails.find((v: any) => v.version_id === selectedVersionId);

    console.log('✓ Found in versionDetails:', selectedVersion);

    // If not found in versionDetails, look in allCustomerData for this specific version
    if (!selectedVersion) {
      console.log('⚠️ Not found in versionDetails, searching in allCustomerData...');
      selectedVersion = this.allCustomerData.find((v: any) =>
        v.project_id === group.project_id &&
        v.currentstage === group.currentstage &&
        v.version_id === selectedVersionId
      );
      console.log('✓ Found in allCustomerData:', selectedVersion);
    }

    if (selectedVersion) {
      // Create new object with all fields from selected version
      const updatedData = {
        ...selectedVersion,
        version_id: selectedVersionId,
        progress: selectedVersion.progress || '0%',
        status: selectedVersion.status || 'N/A',
        upload_status: selectedVersion.upload_status || 'N/A',
        currentstage: selectedVersion.currentstage || group.currentstage
      };

      // Update selectedVersionData to the chosen version
      group.selectedVersionData = updatedData;

      this.selectedVersionId = selectedVersionId;
      this.selectedRowProjectId = Number(group.project_id);
      sessionStorage.setItem('version_id', String(this.selectedVersionId));
      sessionStorage.setItem('project_id', String(this.selectedRowProjectId));

      console.log('✅ Updated selectedVersionData (Costing):', group.selectedVersionData);
      console.log('📊 Progress:', group.selectedVersionData.progress);
      console.log('📊 Status:', group.selectedVersionData.status);
      console.log('📊 Upload Status:', group.selectedVersionData.upload_status);

      this.cdRef.detectChanges();
    } else {
      console.error('❌ Version not found:', selectedVersionId);
    }
  }

  onProcurementVersionChange(event: any, group: any) {
    console.log('🔍 Procurement Version Change - group:', group);

    const selectedProcurementVersionId = Number(event.target.value);
    console.log(`📌 Selected procurement_version_id: ${selectedProcurementVersionId}`);
    console.log('📦 Available procurementVersionDetails:', group.procurementVersionDetails);

    // Find the matching version in procurementVersionDetails (which contains all procurement version data from API)
    let selectedVersion = group.procurementVersionDetails.find((v: any) => v.procurement_version_id === selectedProcurementVersionId);

    console.log('✓ Found in procurementVersionDetails:', selectedVersion);

    // If not found in procurementVersionDetails, look in allCustomerData for this specific version
    if (!selectedVersion) {
      console.log('⚠️ Not found in procurementVersionDetails, searching in allCustomerData...');
      selectedVersion = this.allCustomerData.find((v: any) =>
        v.project_id === group.project_id &&
        v.currentstage === group.currentstage &&
        v.procurement_version_id === selectedProcurementVersionId
      );
      console.log('✓ Found in allCustomerData:', selectedVersion);
    }

    if (selectedVersion) {
      // Create new object with all fields from selected version
      const updatedData = {
        ...selectedVersion,
        procurement_version_id: selectedProcurementVersionId,
        progress: selectedVersion.progress || '0%',
        status: selectedVersion.status || 'N/A',
        upload_status: selectedVersion.upload_status || 'N/A',
        currentstage: selectedVersion.currentstage || group.currentstage
      };

      // Update both selectedProcurementVersionData and selectedVersionData for consistency
      group.selectedProcurementVersionData = updatedData;
      group.selectedVersionData = updatedData;

      this.selectedVersionId = selectedProcurementVersionId;
      this.selectedRowProjectId = Number(group.project_id);
      sessionStorage.setItem('procurement_version_id', String(this.selectedVersionId));
      sessionStorage.setItem('project_id', String(this.selectedRowProjectId));

      console.log('✅ Updated selectedVersionData (Procurement):', group.selectedVersionData);
      console.log('📊 Progress:', group.selectedVersionData.progress);
      console.log('📊 Status:', group.selectedVersionData.status);
      console.log('📊 Upload Status:', group.selectedVersionData.upload_status);

      this.cdRef.detectChanges();
    } else {
      console.error('❌ Procurement version not found:', selectedProcurementVersionId);
    }
  }



  // Start adding a new version (only once per row)
  startAddingNewVersion(versionData: any) {
    if (!versionData.isAddingNewVersion) {
      // For grouped data, get versions array length
      const currentGroup = this.matchedCustomerData.find(g => g.project_id === versionData.project_id);
      if (this.activeTab === 2) {
        const lastProcVersion = currentGroup?.procurementVersions?.length > 0 ? Math.max(...currentGroup.procurementVersions) : (versionData.procurement_version_id || 0);
        versionData.newVersion = lastProcVersion + 1;
      } else {
        const lastVersion = currentGroup?.versions?.length > 0 ? Math.max(...currentGroup.versions) : 0;
        versionData.newVersion = lastVersion + 1; // Suggest the next version number
      }
      versionData.isAddingNewVersion = true;
    }
  }



  saveNewVersion(versionData: any) {
    if (versionData.newVersion) {
      // Find the group this version belongs to
      const group = this.matchedCustomerData.find(g => g.project_id === versionData.project_id);

      if (!group) {
        this.notify.danger('Project group not found.');
        return;
      }

      // Check previous version status
      const previousVersionNum = versionData.newVersion - 1;
      const previousVersionData = group.versionDetails.find((v: any) => v.version_id === previousVersionNum);

      console.log("Previous version data => ", previousVersionData, group.versionDetails);

      if (previousVersionData) {
        const prevStatus = previousVersionData.upload_status?.toLowerCase();
        if (prevStatus === 'new' || prevStatus === 'error') {
          this.notify.danger(`Cannot add new version. Previous version (${previousVersionNum}) is in "${previousVersionData.upload_status}" state.`);
          return;
        }
      } else {
        this.notify.danger("Previous version not found.");
        return;
      }

      // Retrieve version 1 data to get default values
      const version1Data = group.versionDetails.find((v: any) => v.version_id === 1);
      console.log("Version 1 data => ", version1Data, group.versionDetails);

      // Assign values: use current if defined, else fallback to version 1
      const q1Val = versionData.q1 !== undefined ? versionData.q1 : version1Data?.q1;
      const q2Val = versionData.q2 !== undefined ? versionData.q2 : version1Data?.q2;
      const q3Val = versionData.q3 !== undefined ? versionData.q3 : version1Data?.q3;
      const dutyPercentage = versionData.duty_percentage !== undefined
        ? versionData.duty_percentage
        : (version1Data?.duty_percentage || 0);

      // Calculate sequential procurement_version_id if adding in Procurement tab
      let procurementVersionId = 0;
      let usedVersionId = versionData.newVersion; // Default: use new version for Costing tab
      let versionStatus = group.status;

      if (this.activeTab === 2) {
        // Procurement tab: Keep version_id same, only increment procurement_version_id
        usedVersionId = group.selectedVersionData?.version_id || versionData.newVersion;

        // Get the current procurement_version_id and increment by 1
        const currentProcurementVersionId = versionData.procurement_version_id || 0;
        procurementVersionId = currentProcurementVersionId + 1;

        // Whenever creating a new version in procurement stage except first version, status should be Open
        if (procurementVersionId > 1) {
          versionStatus = 'Open';
        }

        console.log(`📦 Procurement Tab - Current procurement_version_id: ${currentProcurementVersionId}, New procurement_version_id: ${procurementVersionId}, Status: ${versionStatus}`);
      }

      // Prepare payload
      const payload = {
        action: "INSERT_NEW_VERSION",
        project_id: versionData.project_id,
        projectName: group.projectName,
        procurement_version_id: procurementVersionId,
        rfqDate: group.rfqDate,
        expectedCompletionDate: versionData.expectedCompletionDate,
        targetLeadTime: group.targetLeadTime,
        created_by_id: versionData.created_by_id,
        created_date: versionData.created_date,
        assigned_to_id: group.assigned_to_id,
        assigned_date: group.assigned_date,
        customer_id: versionData.customer_id,
        ageing: group.ageing,
        progress: versionData.progress,
        status: versionStatus,
        currentstage: versionData.currentstage,
        activestatus: versionData.activestatus,
        version_id: usedVersionId,
        q1: q1Val,
        q2: q2Val,
        q3: q3Val,
        duty_percentage: dutyPercentage
      };

      console.log('🔄 INSERT_NEW_VERSION - Tab:', this.activeTab === 1 ? 'Costing' : 'Procurement', 'version_id:', usedVersionId, 'procurement_version_id:', procurementVersionId, 'Latest max + 1:', procurementVersionId);

      // Update group object with new version
      if (!group.versions.includes(versionData.newVersion)) {
        group.versions.push(versionData.newVersion);
      }
      group.versionDetails.push({
        ...versionData,
        version_id: versionData.newVersion
      });
      group.selectedVersionData = {
        ...versionData,
        version_id: versionData.newVersion
      };
      versionData.isAddingNewVersion = false;

      console.log("Payload being sent:", payload);
      // API call
      this.masterService.manage_projects(payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (result: any) => {
            if (result.status === 'success') {
              this.notify.success('Version updated successfully!');
              // Reload data with the current stage to keep user on the same tab
              const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
              this.getAllOpenProjectData(currentStage);
            } else {
              this.notify.danger('Error updating version. Please try again.');
            }
          },
          (error) => {
            console.error('Error:', error);
            this.notify.danger('Something went wrong. Please check your connection.');
          }
        );
    }
  }



  cancelNewVersion(versionData: any) {
    versionData.isAddingNewVersion = false;
    versionData.newVersion = null;
  }

  onRowSelect(group: any) {
    let role: any = sessionStorage.getItem('role');

    // Get the selected version data from the group
    const selectedVersionData = group.selectedVersionData || group;
    const versionId = Number(selectedVersionData.version_id);
    const projectId = Number(group.project_id);
    const fromProcurement = this.activeTab === 2;

    console.log('Selected Group:', group);
    console.log('Selected Version Data:', selectedVersionData);
    console.log('From Procurement Tab:', fromProcurement);

    const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const engineerIdToStore = currentUser.engineer_id ?? selectedVersionData?.engineer_id ?? selectedVersionData?.assigned_to_id ?? sessionStorage.getItem('user_id') ?? '';
    const managerIdToStore = currentUser.manager_id ?? selectedVersionData?.manager_id ?? sessionStorage.getItem('manager_id') ?? '';
    if (engineerIdToStore !== '') {
      sessionStorage.setItem('engineer_id', String(engineerIdToStore));
    }
    if (managerIdToStore !== '') {
      sessionStorage.setItem('manager_id', String(managerIdToStore));
    }

    if (fromProcurement) {
      // For procurement tab, check procurement_version_id
      const procurementVersionId = Number(selectedVersionData.procurement_version_id);
      this.selectedVersionId = procurementVersionId;
      this.selectedProjectId = projectId;
      this.selectedProjectName = String(group.projectName);

      // Store in session
      sessionStorage.setItem('project_id', String(this.selectedProjectId));
      sessionStorage.setItem('version_id', String(versionId));
      sessionStorage.setItem('procurement_version_id', String(procurementVersionId));
      sessionStorage.setItem('projectName', String(this.selectedProjectName));
      sessionStorage.setItem('dashboard_selected_data', JSON.stringify(selectedVersionData));

      this.menuService.setRole(role);

      // Navigate to project-view with state
      this.router.navigate(['/project-view'], {
        state: {
          customerInfo: selectedVersionData,
          groupInfo: group,
          startIndex: this.paginatestartIndex,
          endIndex: this.paginateendIndex,
          currentPage: this.currentPage,
          rowsPerPage: this.rowsPerPage,
          activeTab: this.activeTab,
          selectedProjectId: projectId,
          selectedVersionId: versionId,
          fromProcurement: true,
          procurementVersionId: procurementVersionId,
          matchedData: this.matchedCustomerData,
        }
      });
    } else if (versionId) {
      this.selectedVersionId = versionId;
      this.selectedProjectId = projectId;
      this.selectedProjectName = String(group.projectName);

      // Store in session
      sessionStorage.setItem('project_id', String(this.selectedProjectId));
      sessionStorage.setItem('version_id', String(this.selectedVersionId));
      sessionStorage.setItem('projectName', String(this.selectedProjectName));
      sessionStorage.setItem('procurement_version_id', '0');
      sessionStorage.setItem('dashboard_selected_data', JSON.stringify(selectedVersionData));

      this.menuService.setRole(role);

      // Navigate to project-view with state
      this.router.navigate(['/project-view'], {
        state: {
          customerInfo: selectedVersionData,
          groupInfo: group,
          startIndex: this.paginatestartIndex,
          endIndex: this.paginateendIndex,
          currentPage: this.currentPage,
          rowsPerPage: this.rowsPerPage,
          activeTab: this.activeTab,
          selectedProjectId: projectId,
          selectedVersionId: versionId,
          fromProcurement: false,
          matchedData: this.matchedCustomerData,
        }
      });
    } else {
      this.notify.info('Please select a version.');
    }
  }

  onSelectProject() {
    this.selectedEngineer = '';
    this.selectedExpetedCompletionDate = '';
    this.applyFilters();
  }

  onSelectCustomer() {
    this.selectedEngineer = '';
    this.selectedExpetedCompletionDate = '';
    this.applyFilters();
  }

  onOpenClickedProject(status: string) {
    this.statusFilter = this.statusFilter === status ? null : status;
    this.applyFilters();
  }

  onOverdueClick() {
    this.statusFilter = this.statusFilter === 'Overdue' ? null : 'Overdue';
    this.applyFilters();
  }

  applyCompletionCategoryFilter() {
    this.isCompletionFiltered = !!this.completionCategoryFilter;
    this.applyFilters();
  }

  clearCompletionFilter() {
    this.completionCategoryFilter = null;
    this.completionCategoryLabel = null;
    this.isCompletionFiltered = false;
    this.applyFilters();
  }


  getOverdueItems(data: any[]) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return data.filter(item => {
      // expectedCompletionDate lives inside selectedVersionData for grouped data
      const ecd = item.selectedVersionData?.expectedCompletionDate || item.expectedCompletionDate;
      if (!ecd) return false;
      const expectedDate = new Date(ecd);
      expectedDate.setHours(0, 0, 0, 0);
      return expectedDate < today && item.status === 'Open';
    });
  }



  onSelectEnginner() {
    this.selectedProjectName = '';
    this.selectedCustomerName = '';
    this.selectedExpetedCompletionDate = '';
    this.matchedCustomerData = this.allCustomerDetails
      .filter((cus: any) => cus.assignedTo === this.selectedEngineer)
      .map((cus: any) => ({
        serialNumber: cus.serialNumber,
        projectName: cus.projectName,
        customerName: cus.customerName,
        rfqDate: cus.rfqDate,
        assignedTo: cus.assignedTo,
        assignedDate: cus.assignedDate,
        expetedCompletionDate: cus.expetedCompletionDate,
        targetLeadTime: cus.targetLeadTime,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        version_id: cus.version_id,
        currentStage: cus.currentStage,
        activeStatus: cus.activeStatus,
      }));
    this.updateTableRows();
  }

  onSelectStage(eve: any) {
    this.selectedCurrentStage = eve?.target?.value || '';
    this.applyFilters();
  }

  getBaseProjectsForActiveTab(): any[] {
    let list: any[] = [];
    if (this.activeTab === 1) {
      list = (this.allCostingProjects && this.allCostingProjects.length > 0)
        ? this.allCostingProjects
        : (this.costingData || []);
    } else {
      list = (this.allProcurementProjects && this.allProcurementProjects.length > 0)
        ? this.allProcurementProjects
        : (this.procurementData || []);
    }
    if ((!list || list.length === 0) && this.allOpenProjectDetails && this.allOpenProjectDetails.length > 0) {
      const stageName = this.activeTab === 1 ? 'costing' : 'procurement';
      list = this.allOpenProjectDetails.filter(p => (p.currentstage || '').toLowerCase() === stageName);
    }
    return list || [];
  }

  parseDate(val: any): Date | null {
    if (!val) return null;
    if (val instanceof Date) {
      return isNaN(val.getTime()) ? null : new Date(val.getTime());
    }
    if (typeof val === 'number') {
      const d = new Date(val);
      return isNaN(d.getTime()) ? null : d;
    }
    if (typeof val === 'string') {
      const str = val.trim();
      if (!str) return null;
      const dmy = str.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
      if (dmy) {
        const d = new Date(parseInt(dmy[3], 10), parseInt(dmy[2], 10) - 1, parseInt(dmy[1], 10));
        return isNaN(d.getTime()) ? null : d;
      }
      const ymd = str.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
      if (ymd) {
        const d = new Date(parseInt(ymd[1], 10), parseInt(ymd[2], 10) - 1, parseInt(ymd[3], 10));
        return isNaN(d.getTime()) ? null : d;
      }
      const d = new Date(str);
      return isNaN(d.getTime()) ? null : d;
    }
    return null;
  }

  isAnyFilterActive(): boolean {
    return !!(
      (this.selectedProjectName && this.selectedProjectName.trim()) ||
      (this.selectedCustomerName && this.selectedCustomerName.trim()) ||
      (this.selectedCurrentStage && this.selectedCurrentStage.trim()) ||
      this.fromExpectedCompletionDate ||
      this.toExpectedCompletionDate ||
      this.fromRfqDate ||
      this.toRfqDate ||
      this.statusFilter ||
      this.completionCategoryFilter
    );
  }

  paginateFilteredData(): void {
    this.currentTabData = this.matchedCustomerData;
    if (String(this.rowsPerPage) === 'All') {
      this.paginatedData = [...this.matchedCustomerData];
    } else {
      const rows = Number(this.rowsPerPage) || 10;
      const startIndex = (this.currentPage - 1) * rows;
      this.paginatedData = this.matchedCustomerData.slice(startIndex, startIndex + rows);
    }
    if (this.activeTab === 1) {
      this.costingPaginatedData = this.paginatedData;
      this.costingCurrentPage = this.currentPage;
    } else {
      this.procurementPaginatedData = this.paginatedData;
      this.procurementCurrentPage = this.currentPage;
    }
  }

  applyFilters() {
    if (!this.isAnyFilterActive()) {
      const stage = this.activeTab === 1 ? 'costing' : 'procurement';
      this.getAllOpenProjectData(stage);
      return;
    }

    const baseData = this.getBaseProjectsForActiveTab();
    const searchProj = (this.selectedProjectName || '').trim().toLowerCase();
    const searchCust = (this.selectedCustomerName || '').trim().toLowerCase();
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.matchedCustomerData = baseData.filter(group => {
      // Project Name filter (partial search / substring)
      if (searchProj) {
        const pName = (group.projectName || '').toLowerCase();
        if (!pName.includes(searchProj)) {
          return false;
        }
      }

      // Customer Name filter (case-insensitive substring or exact match)
      if (searchCust) {
        const cName = (group.customer_name || group.customerName || '').toLowerCase().trim();
        if (cName !== searchCust && !cName.includes(searchCust)) {
          return false;
        }
      }

      // Stage filter
      if (this.selectedCurrentStage && this.selectedCurrentStage.trim()) {
        const stageVal = (group.currentstage || group.currentStage || '').toLowerCase().trim();
        if (stageVal !== this.selectedCurrentStage.toLowerCase().trim()) {
          return false;
        }
      }

      // Status filter
      if (this.statusFilter) {
        if (this.statusFilter === 'Overdue') {
          const ecd = group.selectedVersionData?.expectedCompletionDate || group.expectedCompletionDate;
          if (!ecd) return false;
          const expDate = this.parseDate(ecd);
          if (!expDate) return false;
          expDate.setHours(0, 0, 0, 0);
          if (!(expDate < today && group.status === 'Open')) return false;
        } else if (this.statusFilter === 'ThisMonth') {
          const rfqVal = group.rfqDate || group.selectedVersionData?.expectedCompletionDate || group.expectedCompletionDate;
          if (!rfqVal) return false;
          const rfqDate = this.parseDate(rfqVal);
          if (!rfqDate) return false;
          const now = new Date();
          if (rfqDate.getMonth() !== now.getMonth() || rfqDate.getFullYear() !== now.getFullYear()) {
            return false;
          }
        } else {
          if ((group.status || '').toLowerCase() !== this.statusFilter.toLowerCase()) {
            return false;
          }
        }
      }

      // Completion Category Filter
      if (this.completionCategoryFilter) {
        const progressStr = group.selectedVersionData?.progress?.toString().replace('%', '') || group.progress?.toString().replace('%', '') || '0';
        const progressValue = parseInt(progressStr, 10);
        if (this.completionCategoryFilter === 'lt_50_percent' && !(progressValue < 50)) return false;
        if (this.completionCategoryFilter === '50_75_percent' && !(progressValue >= 50 && progressValue <= 75)) return false;
        if (this.completionCategoryFilter === 'gt_75_percent' && !(progressValue > 75)) return false;
      }

      // Expected Completion Date Range Filter
      if (this.fromExpectedCompletionDate || this.toExpectedCompletionDate) {
        const ecdValue = group.selectedVersionData?.expectedCompletionDate ||
                         group.expectedCompletionDate ||
                         group.selectedProcurementVersionData?.expectedCompletionDate ||
                         group.selectedVersionData?.expetedCompletionDate ||
                         group.expetedCompletionDate;
        if (!ecdValue) return false;
        const expDate = this.parseDate(ecdValue);
        if (!expDate) return false;

        let fromECD = this.fromExpectedCompletionDate ? this.parseDate(this.fromExpectedCompletionDate) : null;
        let toECD = this.toExpectedCompletionDate ? this.parseDate(this.toExpectedCompletionDate) : null;
        if (fromECD) fromECD.setHours(0, 0, 0, 0);
        if (toECD) toECD.setHours(23, 59, 59, 999);

        if (fromECD && toECD && fromECD > toECD) {
          const temp = fromECD;
          fromECD = toECD;
          toECD = temp;
          fromECD.setHours(0, 0, 0, 0);
          toECD.setHours(23, 59, 59, 999);
        }

        if (fromECD && expDate < fromECD) return false;
        if (toECD && expDate > toECD) return false;
      }

      // RFQ Date Range Filter
      if (this.fromRfqDate || this.toRfqDate) {
        const rfqValue = group.rfqDate ||
                         group.selectedVersionData?.rfqDate ||
                         group.selectedProcurementVersionData?.rfqDate ||
                         group.rfq_date ||
                         group.selectedVersionData?.rfq_date;
        if (!rfqValue) return false;
        const rfqDate = this.parseDate(rfqValue);
        if (!rfqDate) return false;

        let fromRFQ = this.fromRfqDate ? this.parseDate(this.fromRfqDate) : null;
        let toRFQ = this.toRfqDate ? this.parseDate(this.toRfqDate) : null;
        if (fromRFQ) fromRFQ.setHours(0, 0, 0, 0);
        if (toRFQ) toRFQ.setHours(23, 59, 59, 999);

        if (fromRFQ && toRFQ && fromRFQ > toRFQ) {
          const temp = fromRFQ;
          fromRFQ = toRFQ;
          toRFQ = temp;
          fromRFQ.setHours(0, 0, 0, 0);
          toRFQ.setHours(23, 59, 59, 999);
        }

        if (fromRFQ && rfqDate < fromRFQ) return false;
        if (toRFQ && rfqDate > toRFQ) return false;
      }

      return true;
    });

    this.currentPage = 1;
    this.paginateFilteredData();
  }



  // Open ECD Modal
  openModalECD() {
    this.showModalECD = true;
  }

  // Close ECD Modal
  closeModalECD() {
    this.showModalECD = false;
    this.applyFilters();
  }

  // Open RFQ Modal
  openModalRFQ() {
    this.showModalRFQ = true;
  }

  // Close RFQ Modal
  closeModalRFQ() {
    this.showModalRFQ = false;
    this.applyFilters();
  }

  resetDates() {
    this.fromExpectedCompletionDate = null;
    this.toExpectedCompletionDate = null;
    this.showModalECD = false;
    this.applyFilters();
  }

  resetRfqDates() {
    this.fromRfqDate = null;
    this.toRfqDate = null;
    this.showModalRFQ = false;
    this.applyFilters();
  }

  // Approval Modal Methods
  openApprovalModal(group: any) {
    this.selectedApprovalProject = {
      ...group,
      ...group.selectedVersionData
    };
    this.showApprovalModal = true;
  }

  closeApprovalModal() {
    this.showApprovalModal = false;
    this.selectedApprovalProject = null;
  }

  submitApprovalRequest() {
    if (!this.selectedApprovalProject) {
      this.notify.danger('No project selected for approval');
      return;
    }

    const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const engineerId = currentUser.engineer_id ?? this.selectedApprovalProject?.assigned_to_id ?? this.userId;
    const managerId = currentUser.manager_id ?? this.selectedApprovalProject?.manager_id ?? 0;

    const payload = {
      "action": "SUBMIT_FOR_APPROVAL",
      "project_id": this.selectedApprovalProject.project_id,
      "version_id": this.activeTab === 1 ? this.selectedApprovalProject.version_id : 0,
      "procurement_version_id": this.activeTab === 2 ? this.selectedApprovalProject.procurement_version_id : 0,
      "projectName": this.selectedApprovalProject.projectName,
      "created_by_id": managerId,
      "assigned_to_id": engineerId,
      "approval_status": this.selectedApprovalStatus || "Pending - Manager Review"
    };

    console.log('Approval Request Payload:', payload);

    this.masterService.manage_projects(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (result: any) => {
          if (result.status === 'success') {
            this.notify.success('Approval request submitted successfully!');
            this.closeApprovalModal();
            // Reload data to refresh the table
            const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
            this.getAllOpenProjectData(currentStage);
          } else {
            this.notify.danger(result.message || 'Error submitting approval request. Please try again.');
          }
        },
        (error) => {
          console.error('Approval Request Error:', error);
          this.notify.danger('Something went wrong. Please check your connection.');
        }
      );
  }




  onSelectCompletionDate() {
    this.applyFilters();
  }

  onDateRangeChange() {
    this.applyFilters();
  }
  onSelectMonthRfq() {
    this.matchedCustomerData = this.allCustomerData
      .filter((cus: any) => cus.customerName === this.selectedCustomerName)
      .map((cus: any) => ({
        serialNumber: cus.serialNumber,
        projectName: cus.projectName,
        customerName: cus.customerName,
        rfqDate: cus.rfqDate,
        assignedTo: cus.assignedTo,
        assignedDate: cus.assignedDate,
        expetedCompletionDate: cus.expetedCompletionDate,
        targetLeadTime: cus.targetLeadTime,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        version_id: cus.version_id,
        upload_status: cus.upload_status,
        currentStage: cus.currentStage,
        activeStatus: cus.activeStatus,
      }));
  }

  activeTab: number = 1; // Track the active tab (1 = Costing, 2 = Procurement)

  // Filtered data for each tab
  costingData: any[] = [];
  procurementData: any[] = [];
  currentTabData: any[] = []; // Data to display based on active tab

  // Pagination for each tab
  costingPaginatedData: any[] = [];
  procurementPaginatedData: any[] = [];
  costingCurrentPage: number = 1;
  procurementCurrentPage: number = 1;
  costingRowsPerPage: any = 10;
  procurementRowsPerPage: any = 10;

  // State persistence for navigation
  highlightedProjectId: any = null; // Store project ID for row highlighting
  restoredState: boolean = false; // Flag to prevent multiple restorations

  // Method to set the active tab
  setActiveTab(tabNumber: number): void {
    if (this.activeTab === tabNumber) return;
    console.log(`📌 Switching from Tab ${this.activeTab} to Tab ${tabNumber}`);

    this.activeTab = tabNumber;

    if (this.isAnyFilterActive()) {
      this.currentPage = 1;
      this.applyFilters();
      return;
    }

    if (this.activeTab === 1) {
      this.currentPage = this.costingCurrentPage || 1;
      this.rowsPerPage = this.costingRowsPerPage || 10;
      this.totalProjectsCount = this.costingTotalCount;
    } else {
      this.currentPage = this.procurementCurrentPage || 1;
      this.rowsPerPage = this.procurementRowsPerPage || 10;
      this.totalProjectsCount = this.procurementTotalCount;
    }

    const stage = this.activeTab === 1 ? 'costing' : 'procurement';
    this.getAllOpenProjectData(stage);
  }

  // Filter data based on current stage and populate tab-specific data
  filterAndDisplayTabData(): void {
    if (this.activeTab === 1) {
      this.currentTabData = this.costingData;
      this.currentPage = this.costingCurrentPage;
      this.rowsPerPage = this.costingRowsPerPage;
      this.totalProjectsCount = this.costingTotalCount;
    } else {
      this.currentTabData = this.procurementData;
      this.currentPage = this.procurementCurrentPage;
      this.rowsPerPage = this.procurementRowsPerPage;
      this.totalProjectsCount = this.procurementTotalCount;
    }
    this.paginatedData = [...this.currentTabData];
    this.updateCardCounts();
  }

  // Restore navigation state after returning from Project View
  // Called only when navigationState.activeTab is present (coming from Project View)
  restoreNavigationState(navigationState: any): void {
    if (!navigationState || this.restoredState) {
      return;
    }

    console.log('🔄 Restoring: Tab=' + navigationState.activeTab +
      ' Page=' + navigationState.currentPage +
      ' ProjectId=' + navigationState.selectedProjectId);

    // Restore active tab
    const restoredTab = navigationState.activeTab;
    if (restoredTab && restoredTab !== this.activeTab) {
      this.activeTab = restoredTab;
    }

    // Restore pagination state (for the active tab)
    if (navigationState.currentPage) {
      if (this.activeTab === 1) {
        this.costingCurrentPage = navigationState.currentPage;
        this.currentPage = this.costingCurrentPage;
        if (navigationState.rowsPerPage) {
          this.costingRowsPerPage = navigationState.rowsPerPage;
          this.rowsPerPage = this.costingRowsPerPage;
        }
      } else if (this.activeTab === 2) {
        this.procurementCurrentPage = navigationState.currentPage;
        this.currentPage = this.procurementCurrentPage;
        if (navigationState.rowsPerPage) {
          this.procurementRowsPerPage = navigationState.rowsPerPage;
          this.rowsPerPage = this.procurementRowsPerPage;
        }
      }
    }

    // Restore highlighted row
    if (navigationState.selectedProjectId) {
      this.highlightedProjectId = navigationState.selectedProjectId;
      console.log('✅ Row highlighted for project ID:', this.highlightedProjectId);
    }

    this.restoredState = true;
    const stage = this.activeTab === 1 ? 'costing' : 'procurement';
    this.getAllOpenProjectData(stage);
  }

  // Update rows for active tab
  updateTableRowsForTabs(): void {
    if (this.isAnyFilterActive()) {
      this.paginateFilteredData();
      return;
    }
    this.onPageSizeChange();
  }

  // Paginate for active tab
  paginateForTabs(): void {
    if (this.isAnyFilterActive()) {
      this.paginateFilteredData();
      return;
    }
    this.paginatedData = [...this.currentTabData];
  }

  // Get total pages for active tab
  getTotalPagesForTab(): number {
    const total = this.getTotalCountForTab();
    if (String(this.rowsPerPage) === 'All') return 1;
    const rows = Number(this.rowsPerPage) || 10;
    if (!total || total <= 0) return 1;
    return Math.ceil(total / rows) || 1;
  }

  // Get start index for active tab
  getStartIndexForTab(): number {
    const total = this.getTotalCountForTab();
    if (!total || total === 0 || this.paginatedData.length === 0) return 0;
    if (String(this.rowsPerPage) === 'All') return 1;
    const rows = Number(this.rowsPerPage) || 10;
    return (this.currentPage - 1) * rows + 1;
  }

  // Get end index for active tab
  getEndIndexForTab(): number {
    const total = this.getTotalCountForTab();
    if (!total || total === 0 || this.paginatedData.length === 0) return 0;
    if (String(this.rowsPerPage) === 'All') return total;
    const rows = Number(this.rowsPerPage) || 10;
    return Math.min(this.currentPage * rows, total);
  }

  getTotalCountForTab(): number {
    if (this.isAnyFilterActive()) {
      return this.matchedCustomerData ? this.matchedCustomerData.length : 0;
    }
    return this.activeTab === 1 ? this.costingTotalCount : this.procurementTotalCount;
  }

  getVisiblePages(): (number | string)[] {
    const totalPages = this.getTotalPagesForTab();
    const current = this.currentPage;

    if (totalPages <= 7) {
      const pages: number[] = [];
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    if (current <= 4) {
      return [1, 2, 3, 4, 5, '...', totalPages];
    } else if (current >= totalPages - 3) {
      return [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      return [1, '...', current - 1, current, current + 1, '...', totalPages];
    }
  }

  back() {
    // Check if we came from source-pulse, if so navigate back to it
    if (this.fromSourcePulse) {
      console.log("🔙 Navigating back to Source Pulse");
      this.router.navigate(['/dashboard-engineer/source-pulse']);
      return;
    }

    this.router.navigate(['/master/additional-charges/table']);
  }



  private getDismissReason(reason: any): string {
    if (reason === 'ESC') {
      return 'by pressing ESC';
    } else if (reason === 'BACKDROP_CLICK') {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  resetFields() {
    this.isRefresh = true; // Show loader
    this.selectedProjectName = '';
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    this.selectedRfqDate = '';
    this.fromExpectedCompletionDate = null;
    this.toExpectedCompletionDate = null;
    this.fromRfqDate = null;
    this.toRfqDate = null;
    this.statusFilter = null;
    this.completionCategoryFilter = null;
    this.completionCategoryLabel = null;
    this.isCompletionFiltered = false;
    this.currentPage = 1;
    this.costingCurrentPage = 1;
    this.procurementCurrentPage = 1;
    this.showProjectDropdown = false;
    this.filteredProjectNames = [];
    this.resetFinalData();
    this.getAllcustomers();
    // Reload data with the current stage to keep user on the same tab
    const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
    this.fetchStageCounts();
    this.getAllOpenProjectData(currentStage);
  }
  openProjectModel(projectModal: any, customer?: any, projectId?: any) {
    this.previousStage = customer?.currentstage || customer?.currentStage || null;

    if (customer) {
      this.selectedCustomerId = customer.customer_id;
      this.selectedmatchedCustomerData = customer;
      this.selectedProjectId = customer.project_id;

      const cName = customer.customer_name || customer.customerName;
      if (cName && !this.allCustomerDetails?.some((c: any) => (c.customerName || c.customer_name || '').toLowerCase() === cName.toLowerCase())) {
        this.allCustomerDetails = [
          ...(this.allCustomerDetails || []),
          { customerName: cName, customer_name: cName, customer_id: customer.customer_id || null }
        ].sort((a: any, b: any) => a.customerName.localeCompare(b.customerName));
      }
    }

    this.showAddCustomerButton = false;

    this.modalRef = this.modalService.open(projectModal, { 
      ariaLabelledBy: 'modal-basic-title', 
      size: 'lg' 
    });

    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

    // ====== EDIT MODE ======
    if (customer) {
      this.patchCustomerData(customer);

      this.onQn123 = {
        q1: customer.q1 == true || customer.q1 == 'true' || customer.q1 == 1 || customer.q1 == 'yes',
        q2: customer.q2 == true || customer.q2 == 'true' || customer.q2 == 1 || customer.q2 == 'yes',
        q3: customer.q3 == true || customer.q3 == 'true' || customer.q3 == 1 || customer.q3 == 'yes',
      };

      this.dutyValuePercentage = customer.duty_percentage;
      this.showQn2 = this.onQn123.q1;
      this.showQn3 = this.onQn123.q2;
      this.showDutyInput = this.onQn123.q3;
    } else {
      // ====== ADD MODE ======
      this.selectedCustomerId = null;
      this.selectedmatchedCustomerData = null;
      this.selectedProjectId = null;
      this.showAddButton = false;
      this.searchText = '';
      this.isProjectNameDuplicate = false;

      this.projectForm.reset();
      const defaultAssignTo = this.userId ? Number(this.userId) : null;
      const defaultStage = this.activeTab === 2 ? 'Procurement' : 'Costing';
      this.projectForm.patchValue({
        version_id: 1,
        assignTo: defaultAssignTo,
        currentStage: defaultStage
      });
      this.projectForm.get('version_id')?.disable();

      this.onQn123 = { q1: null, q2: null, q3: null };
      this.dutyValuePercentage = null as any;
      this.showQn2 = false;
      this.showQn3 = false;
      this.showDutyInput = false;

      this.getAllcustomers();
    }
  }

  patchCustomerData(selectedmatchedCustomerData: any) {
    this.projectForm.patchValue({
      newProjectName: selectedmatchedCustomerData.projectName,
      customerFullName: selectedmatchedCustomerData.customer_name || selectedmatchedCustomerData.customerName,
      rfqDate: selectedmatchedCustomerData.rfqDate,
      completionDate: selectedmatchedCustomerData.expectedCompletionDate,
      targetLT: selectedmatchedCustomerData.targetLeadTime,
      assignTo: selectedmatchedCustomerData.assigned_to_id,
      currentStage: selectedmatchedCustomerData.currentstage || selectedmatchedCustomerData.currentStage,
      version_id: selectedmatchedCustomerData.version_id
    });
    this.projectForm.get('version_id')?.disable();
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.close();
      this.showAddCustomerButton = false;
    } else {
      this.modalService.dismissAll();
      this.showAddCustomerButton = false;
    }
    this.modalService.dismissAll();
  }

  openCustomerModel(customerModal: any, prefillName?: string) {
    const nameToPrefill = (prefillName || this.searchText || '').trim();
    if (nameToPrefill) {
      this.customerForm.patchValue({
        _customerFullName: nameToPrefill
      });
      this.searchText = nameToPrefill;
      this.isCustomerNameDuplicate = (this.allCustomerDetails || []).some(
        (customer: any) => (customer.customerName || customer.customer_name || '').toLowerCase() === nameToPrefill.toLowerCase()
      );
    }

    this.customerModalRef = this.modalService.open(customerModal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });

    this.customerModalRef.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
      this.customerModalRef = null;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.customerModalRef = null;
    });
  }

  closeCustomerModal() {
    if (this.customerModalRef) {
      this.customerModalRef.close('dismissed');
      this.customerModalRef = null;
    }
    this.customerForm.reset();
    this.showAddCustomerButton = false;
    this.isCustomerNameDuplicate = false;
  }

  saveCustomer() {
    if (this.customerForm.invalid || this.isCustomerNameDuplicate) {
      this.customerForm.markAllAsTouched();
      this.notify.info('Please fill in all required customer fields.');
      return;
    }

    if (this.isSaving) {
      return;
    }

    this.isSaving = true;

    const newCustomerName = (this.customerForm.get('_customerFullName')?.value || '').trim();
    const payload = {
      customerName: newCustomerName,
      city: (this.customerForm.get('city')?.value || '').trim(),
      state: (this.customerForm.get('state')?.value || '').trim(),
      country: (this.customerForm.get('country')?.value || '').trim(),
      gstNumber: (this.customerForm.get('gstNumber')?.value || '').trim(),
    };

    this.masterService.create_customers(payload).pipe(
      catchError((error) => {
        console.error('Error saving customer data:', error);
        this.notify.danger('An error occurred while saving the customer data. Please try again.');
        this.isSaving = false;
        this.cdRef.detectChanges();
        return of(null);
      })
    ).subscribe({
      next: (response) => {
        this.isSaving = false;
        if (response) {
          this.notify.success('Customer saved successfully.');

          // Extract created ID safely from all possible response formats:
          // Backend returns: { status: 'success', code: 201, record: [{ id: 59, customerName: '...' }] }
          const recordItem = Array.isArray(response?.record)
            ? response.record[0]
            : (response?.record ?? null);
          const dataItem = Array.isArray(response?.data)
            ? response.data[0]
            : (response?.data ?? null);

          const rawId = recordItem?.id ?? recordItem?.customer_id ??
                        dataItem?.id ?? dataItem?.customer_id ??
                        response?.id ?? response?.customer_id ?? null;
          const createdId = rawId ? Number(rawId) : null;

          const createdName = (
            recordItem?.customerName || recordItem?.customer_name ||
            dataItem?.customerName || dataItem?.customer_name ||
            newCustomerName
          ).trim();

          const newEntry = {
            customerName: createdName,
            customer_name: createdName,
            customer_id: createdId,
            id: createdId
          };

          const remaining = (this.allCustomerDetails || []).filter(
            (c: any) => (c.customerName || c.customer_name || '').trim().toLowerCase() !== createdName.toLowerCase()
          );
          this.allCustomerDetails = [...remaining, newEntry].sort((a: any, b: any) =>
            (a.customerName || '').localeCompare(b.customerName || '')
          );

          // Auto-select the newly created customer in projectForm
          this.projectForm.get('customerFullName')?.setValue(createdName);
          this.projectForm.get('customerFullName')?.markAsDirty();
          this.projectForm.get('customerFullName')?.updateValueAndValidity();

          this.selectedCustomerId = createdId;
          this.showAddButton = false;
          this.searchText = '';

          // Reset and close customer modal
          this.customerForm.reset();
          if (this.customerModalRef) {
            this.customerModalRef.close('saved');
            this.customerModalRef = null;
          }
          this.showAddCustomerButton = false;
          this.isCustomerNameDuplicate = false;

          // REFRESH customers from backend and guarantee customer is selected
          this.getAllcustomers(() => {
            if (createdName) {
              const matched = (this.allCustomerDetails || []).find(
                (c: any) => (c.customerName || c.customer_name || '').trim().toLowerCase() === createdName.toLowerCase()
              );
              if (matched) {
                const refreshedId = matched.customer_id ?? matched.id;
                if (refreshedId) {
                  this.selectedCustomerId = Number(refreshedId);
                }
              }
              this.projectForm.get('customerFullName')?.setValue(createdName);
              this.projectForm.get('customerFullName')?.markAsDirty();
              this.projectForm.get('customerFullName')?.updateValueAndValidity();
            }
            this.cdRef.detectChanges();
          });

          this.cdRef.detectChanges();
        }
      },
      error: (error) => {
        this.isSaving = false;
        console.error('Unexpected error saving customer:', error);
        this.cdRef.detectChanges();
      }
    });
  }

  onAddNewCustomer(event?: any): void {
    if (!event) {
      this.selectedCustomerId = null;
      this.showAddButton = false;
      return;
    }

    const customerName = typeof event === 'string' ? event : (event?.customerName || event?.customer_name);
    let customerId = typeof event === 'object' ? (event?.customer_id ?? event?.id) : null;

    if (!customerId && customerName) {
      const matched = (this.allCustomerDetails || []).find(
        (c: any) => (c.customerName || c.customer_name || '').trim().toLowerCase() === customerName.trim().toLowerCase()
      );
      if (matched) {
        customerId = matched.customer_id ?? matched.id;
      }
    }

    this.selectedCustomerId = customerId ? Number(customerId) : null;
    this.showAddButton = false;
    this.searchText = '';
    console.log('Customer selected:', customerName, 'ID:', this.selectedCustomerId);
  }

  onCustomerSearch(event: any): void {
    const term = (event?.term ?? event?.target?.value ?? (typeof event === 'string' ? event : '')).trim();
    this.searchText = term;

    if (!term) {
      this.showAddButton = false;
      return;
    }

    const exists = (this.allCustomerDetails || []).some(
      (c: any) => (c.customerName || c.customer_name || '').toLowerCase() === term.toLowerCase()
    );

    this.showAddButton = !exists;
  }

  onCustomerClear(): void {
    this.selectedCustomerId = null;
    this.showAddButton = false;
    this.searchText = '';
    this.projectForm.get('customerFullName')?.setValue(null);
  }

  enterProject(eve: any): void {
    let enteredProject = (eve?.target?.value || '').trim();
    const existingList = this.allCostingProjects.concat(this.allProcurementProjects, this.allCustomerData || []);
    this.isProjectNameDuplicate = existingList.some(
      (project: any) => (project.projectName || '').toLowerCase() === enteredProject.toLowerCase()
    );
  }

  onEnterCustomerName(eve: any): void {
    let enteredCustomer = (eve?.target?.value || '').trim();
    this.isCustomerNameDuplicate = (this.allCustomerDetails || []).some(
      (customer: any) => (customer.customerName || customer.customer_name || '').toLowerCase() === enteredCustomer.toLowerCase()
    );
  }

  updateRfqDate() {
    const startDate = this.projectForm.get('rfqDate')?.value;
    if (startDate) {
      let nextDay = new Date(startDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.nextMaxDate = nextDay.toISOString().split('T')[0];
      this.isExpectedCompletionDateDisabled = false;
      this.projectForm.get('completionDate')?.enable();
    } else {
      this.isExpectedCompletionDateDisabled = true;
    }
  }

  updatecompletionDate() {
    const startDate = this.projectForm.get('rfqDate')?.value;
    if (!startDate) {
      this.projectForm.get('completionDate')?.setValue('');
      this.notify.danger('Please Select the RFQ date Before choosing an Expected Completion Date');
    }
  }

  onLandinCost(landinCostModal: any) {
    this.modalRef = this.modalService.open(landinCostModal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });

    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  onQn1Change(answer: string, modal?: any) {
    if (answer === 'yes') {
      this.showQn2 = true;
      this.onQn123.q1 = true;
    } else {
      this.showQn2 = false;
      this.showQn3 = false;
      this.showDutyInput = false;
      this.onQn123.q1 = false;
      this.onQn123.q2 = null;
      this.onQn123.q3 = null;
      this.dutyValuePercentage = 0;
      if (modal) {
        this.saveLandingCost(modal);
      }
    }
  }

  onQn2Change(answer: string, modal?: any) {
    if (answer === 'yes') {
      this.showQn3 = true;
      this.onQn123.q2 = true;
    } else {
      this.showQn3 = false;
      this.showDutyInput = false;
      this.onQn123.q2 = false;
      this.onQn123.q3 = null;
      this.dutyValuePercentage = 0;
      if (modal) {
        this.saveLandingCost(modal);
      }
    }
  }

  onQn3Change(value: string, modal?: any) {
    if (value === 'export' || value === 'yes') {
      this.showDutyInput = true;
      this.onQn123.q3 = true;
    } else {
      this.showDutyInput = false;
      this.onQn123.q3 = false;
      this.dutyValuePercentage = 0;
      if (modal) {
        this.saveLandingCost(modal);
      }
    }
  }

  saveLandingCost(modal?: any) {
    const payload: any = {};
    if (this.onQn123.q1 === true) {
      payload.landingcost = true;
      if (this.onQn123.q2 === true) {
        payload.dutiesofcalclandingcost = true;
        if (this.onQn123.q3 !== null) {
          payload.dutyvalue = this.onQn123.q3;
          if (this.onQn123.q3 === true && this.dutyValuePercentage !== null) {
            payload.dutyvaluepercentage = this.dutyValuePercentage;
          }
        }
      } else {
        payload.dutiesofcalclandingcost = false;
      }
    } else {
      payload.landingcost = false;
    }

    if (modal) {
      modal.close(payload);
    } else {
      this.modalService.dismissAll();
    }
  }

  closeLandingCost(modal?: any) {
    this.resetQuestions();
    if (modal) {
      modal.close();
    }
  }

  resetQuestions() {
    this.showQn2 = false;
    this.showQn3 = false;
  }

  keepLandingCostValues() {
    console.log("Keeping previous Landing Cost values:", this.onQn123, this.dutyValuePercentage);
  }

  save(): void {
    if (this.onQn123.q1 === null) {
      this.notify.info("Please answer Landing Cost question (Q1).");
      return;
    }
    if (this.onQn123.q1 === true && this.onQn123.q2 === null) {
      this.notify.info("Please answer Duties question (Q2).");
      return;
    }
    if (this.onQn123.q2 === true && this.onQn123.q3 === null) {
      this.notify.info("Please answer Duty Value question (Q3).");
      return;
    }
    if (this.onQn123.q3 === true && (!this.dutyValuePercentage || this.dutyValuePercentage <= 0)) {
      this.notify.info("Please enter a valid Duty Value Percentage.");
      return;
    }

    if (!this.selectedProjectId) {
      let enteredProject: any = this.projectForm.value.newProjectName;
      if (this.isProjectNameDuplicate) {
        this.notify.info('Project already available, choose a different Project Name.');
        return;
      }
      const existingList = this.allCostingProjects.concat(this.allProcurementProjects, this.allCustomerData || []);
      if (existingList.some((project: any) => (project.projectName || '').toLowerCase() === (enteredProject || '').trim().toLowerCase())) {
        this.notify.info('Project already available, choose a different Project Name.');
        return;
      }
    }

    if (this.isSaving) {
      return;
    }

    this.isSaving = true;
    let payload: any;

    if (this.projectForm.valid) {
      const currentCustName = this.projectForm.get('customerFullName')?.value;
      if (!this.selectedCustomerId && currentCustName) {
        const found = (this.allCustomerDetails || []).find(
          (c: any) => (c.customerName || c.customer_name || '').trim().toLowerCase() === currentCustName.trim().toLowerCase()
        );
        if (found?.customer_id || found?.id) {
          this.selectedCustomerId = Number(found.customer_id ?? found.id);
        }
      }

      const assignedToId = Number(this.projectForm.get('assignTo')?.value) || Number(this.userId) || 0;
      const todayStr = this.currentDate || new Date().toISOString().split('T')[0];

      let creatorId = Number(this.managerId) || Number(sessionStorage.getItem('manager_id'));
      if (!creatorId) {
        const userDetailsStr = sessionStorage.getItem('userDetails');
        if (userDetailsStr) {
          try {
            const ud = JSON.parse(userDetailsStr);
            if (ud?.manager_id && !isNaN(Number(ud.manager_id))) {
              creatorId = Number(ud.manager_id);
              this.managerId = creatorId;
            }
          } catch (e) {}
        }
      }
      if (!creatorId) {
        creatorId = Number(this.userId) || 0;
      }

      if (!this.selectedProjectId) {
        payload = {
          action: "INSERT",
          project_id: 0,
          version_id: 1,
          projectName: this.projectForm.get('newProjectName')?.value,
          procurement_version_id: 0,
          rfqDate: this.projectForm.get('rfqDate')?.value,
          expectedCompletionDate: this.projectForm.get('completionDate')?.value,
          targetLeadTime: Number(this.projectForm.get('targetLT')?.value),
          created_by_id: creatorId,
          created_date: todayStr,
          assigned_to_id: assignedToId,
          assigned_date: this.assignDate || todayStr,
          customer_id: Number(this.selectedCustomerId) || 0,
          ageing: 0,
          progress: "0%",
          status: "Open",
          currentstage: this.projectForm.get('currentStage')?.value,
          activestatus: ""
        };
        this.projectForm.get('version_id')?.disable();
      }

      if (this.selectedProjectId) {
        payload = {
          action: "UPDATE",
          project_id: this.selectedProjectId,
          version_id: this.selectedmatchedCustomerData?.version_id || 1,
          procurement_version_id: 0,
          projectName: this.projectForm.get('newProjectName')?.value,
          rfqDate: this.projectForm.get('rfqDate')?.value,
          expectedCompletionDate: this.projectForm.get('completionDate')?.value,
          targetLeadTime: Number(this.projectForm.get('targetLT')?.value),
          created_by_id: Number(this.selectedmatchedCustomerData?.created_by_id) || creatorId,
          created_date: todayStr,
          assigned_to_id: assignedToId,
          assigned_date: this.selectedmatchedCustomerData?.assigned_date || todayStr,
          customer_id: Number(this.selectedCustomerId) || 0,
          ageing: this.selectedmatchedCustomerData?.ageing || 0,
          progress: this.selectedmatchedCustomerData?.progress || "0%",
          status: this.selectedmatchedCustomerData?.status || "Open",
          currentstage: this.projectForm.get('currentStage')?.value,
          activestatus: this.selectedmatchedCustomerData?.activestatus || ""
        };
        this.projectForm.get('version_id')?.disable();
      }

      if (this.previousStage === 'Costing' && this.projectForm.get('currentStage')?.value === 'Procurement') {
        payload.q1 = this.selectedmatchedCustomerData?.q1;
        payload.q2 = this.selectedmatchedCustomerData?.q2;
        payload.q3 = this.selectedmatchedCustomerData?.q3;
        payload.duty_percentage = this.selectedmatchedCustomerData?.duty_percentage;
      } else {
        payload.q1 = this.onQn123.q1 === true;
        payload.q2 = this.onQn123.q2 === true;
        payload.q3 = this.onQn123.q3 === true;
        payload.duty_percentage = this.onQn123.q3 === true ? this.dutyValuePercentage || 0 : 0;
      }

      const isChangingToProcurement = 
        this.projectForm.get('currentStage')?.value === 'Procurement' &&
        this.previousStage !== 'Procurement' &&
        this.selectedProjectId;

      if (isChangingToProcurement) {
        payload.action = "MOVE_TO_PROCUREMENT";
        payload.progress = "0%";
        const existingProcurementCount = this.allProcurementProjects.filter((project: any) => 
          project.project_id === this.selectedProjectId
        ).length;
        payload.procurement_version_id = existingProcurementCount + 1;
      } else {
        const currentStage = this.projectForm.get('currentStage')?.value;
        payload.procurement_version_id = currentStage === 'Procurement' ? 1 : 0;
      }

      console.log('Final Payload:', payload);

      this.masterService.manage_projects(payload).pipe(
        catchError((error) => {
          console.error('Error saving project data:', error);
          this.notify.danger('An error occurred while saving the project data. Please try again.');
          return of(null);
        })
      ).subscribe({
        next: (response) => {
          if (response) {
            this.notify.success('Project saved successfully.');
            this.projectForm.reset();
            this.closeModal();
            this.loadBothStages();
            this.fetchStageCounts();
          }
        },
        error: (error) => {
          console.error('Unexpected error:', error);
        },
        complete: () => {
          this.isSaving = false;
          this.closeModal();
          this.projectForm.reset();
        }
      });
    } else {
      this.projectForm.markAllAsTouched();
      this.notify.info('Please fill in all required fields.');
      this.isSaving = false;
    }
  }

  dragNdropIncor(event: any) {

    this.incorUploadFiles = [];
    this.selectedIncorFile = event.target.files;
    for (var i = 0; i < this.selectedIncorFile.length; i++) {
      if (this.selectedIncorFile[i]) {
        const file = this.selectedIncorFile[i];
        var reader = new FileReader();
        reader.onload = (event: any) => {
          var str = event.target.result;
          var name = file.name.split('.').slice(0, -1).join('.');
          var type = file.type;
          var size = file.size;
          var exe = file.name.split('.').pop();

          var splitField = str
            .replace('data:', '')
            .replace(/^.+,/, '');

          let allFiles = {
            fileName: name,
            fileExtension: exe,

            fileByte: splitField
          }
          this.incorUploadFiles.push(allFiles);
          let form: any = this.form

          let temp = this.form.value.source_file_name;
          if (temp == "") {
            form.get('source_file_name').patchValue(file.name);
          } else {
            form.get('source_file_name').patchValue(temp + ', ' + file.name);
          }
        }
        reader.readAsDataURL(this.selectedIncorFile[i]);
      }
    }
    console.log('uploaded Files', this.incorUploadFiles)
  }


  selectedGroup: any;

  uploadSourcingList(uploadFileModal: any, engineer: any, group?: any) {
    this.selectedGroup = group || (this.paginatedData ? this.paginatedData.find((g: any) => g.project_id === engineer?.project_id) : null);
    this.selectedProjectId = engineer?.project_id || group?.project_id;
    this.selectedEngineerData = engineer; // Store full engineer data to access procurement_version_id later
    this.selectedVersionId = engineer?.version_id;
    this.selectedProjectName = engineer?.projectName || group?.projectName; // Capture project name for fetchReleaseList

    if (!this.selectedVersionId) {

      this.notify.info('Please select version_id.')
      return
    }
    this.modalRef = this.modalService.open(uploadFileModal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'upload-files-modal-window',
      scrollable: true,
      backdrop: 'static'
    });
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  navigateToAddPartManually() {
    this.closeUploadModal();

    const group = this.selectedGroup || (this.paginatedData ? this.paginatedData.find((g: any) => g.project_id === this.selectedProjectId) : null) || this.selectedEngineerData || {};
    const selectedVersionData = this.selectedEngineerData || group?.selectedVersionData || group;
    const versionId = Number(this.selectedVersionId || selectedVersionData?.version_id || 1);
    const projectId = Number(this.selectedProjectId || group?.project_id || selectedVersionData?.project_id);
    const fromProcurement = this.activeTab === 2;
    const role: any = sessionStorage.getItem('role');

    const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const engineerIdToStore = currentUser.engineer_id ?? selectedVersionData?.engineer_id ?? selectedVersionData?.assigned_to_id ?? sessionStorage.getItem('user_id') ?? '';
    const managerIdToStore = currentUser.manager_id ?? selectedVersionData?.manager_id ?? sessionStorage.getItem('manager_id') ?? '';
    if (engineerIdToStore !== '') {
      sessionStorage.setItem('engineer_id', String(engineerIdToStore));
    }
    if (managerIdToStore !== '') {
      sessionStorage.setItem('manager_id', String(managerIdToStore));
    }

    const procurementVersionId = Number(selectedVersionData?.procurement_version_id || 0);

    sessionStorage.setItem('project_id', String(projectId));
    sessionStorage.setItem('version_id', String(versionId));
    sessionStorage.setItem('procurement_version_id', String(fromProcurement ? procurementVersionId : 0));
    if (this.selectedProjectName || group?.projectName) {
      sessionStorage.setItem('projectName', String(this.selectedProjectName || group?.projectName));
    }
    sessionStorage.setItem('dashboard_selected_data', JSON.stringify(selectedVersionData));

    this.menuService.setRole(role);

    this.router.navigate(['/project-view'], {
      state: {
        customerInfo: selectedVersionData,
        groupInfo: group,
        startIndex: this.paginatestartIndex,
        endIndex: this.paginateendIndex,
        currentPage: this.currentPage,
        rowsPerPage: this.rowsPerPage,
        activeTab: this.activeTab,
        selectedProjectId: projectId,
        selectedVersionId: versionId,
        fromProcurement: fromProcurement,
        procurementVersionId: procurementVersionId,
        matchedData: this.matchedCustomerData,
        openManualAddModal: true
      }
    });
  }



  // This function is triggered when a file is selected
  uploadSourcingListFiles(event: any) {
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const wsname2: string = wb.SheetNames[1];
      const ws2: XLSX.WorkSheet = wb.Sheets[wsname2];

      this.data = XLSX.utils.sheet_to_json(ws);
      this.sourcingRawData = [...this.data];
      let customObjFromExcel = XLSX.utils.sheet_to_json(ws2);
      this.dataProp = Object.getOwnPropertyNames(this.data[0]);

      // Remove "__rowNum__" property if it exists
      for (var j = 0; j < this.dataProp.length; j++) {
        if (this.dataProp[j] == "__rowNum__") {
          this.dataProp.splice(j, 1);
        }
      }
      this.uploadedHeaders = Object.keys(this.data[0]).filter(h => h !== '__rowNum__');
      this.fieldMapping = {};
      this.uploadedHeaders.forEach(header => {
        this.fieldMapping[header] = null;
      });
      this.validateHeaders();
      this.sourceListData = [];
      let form: any = this.form
      // Set the file name in the variable
      this.sourcingListFileName = target.files[0].name;
      console.log(this.sourcingListFileName); // Display file name in console

      form.get('sourcingListFileName').setValue(this.sourcingListFileName); // Optionally update form control

      console.log(this.data);
      for (let i = 0; i < this.data.length; i++) {
        let obj = {
          SlNo: this.data[i]['Sl no'],
          customerPartNumber: String(this.data[i]['Customer Part No.']).trim(),
          internalPartNo: String(this.data[i]['Internal Part No.']).trim(),
          description: String(this.data[i]['Description']).trim(),
          specification: String(this.data[i]['Specification']).trim().replace(/\s+/g, ''),
          commodity: String(this.data[i]['Commodity']).trim(),
          manufacturer: String(this.data[i]['Manufacturer(Mfg)']).trim(),
          uom: String(this.data[i]['UOM']).trim(),
          projectQty: Number(this.data[i]['Project qty']),
          iSourcing: String(this.data[i]['I Sourcing']).trim(),
        };
        this.sourceListData.push(obj);
        if (this.avdData.length === 0) {
          this.finalDataList = this.sourceListData;
        }
        console.log('sourceListData', this.sourceListData);
      }
    };
  }

  validateHeaders() {
    this.headerErrorMessage = '';
    this.isHeaderMappingRequired = false;

    const normalize = (str: string) => str?.toLowerCase().replace(/\s+/g, '').trim();

    // Define optional headers here
    const optionalHeaders = ['I Sourcing'];

    const expectedLabels = this.expectedFields
      .filter(f => !optionalHeaders.includes(f.label)) // remove optional from required list
      .map(f => normalize(f.label));

    const uploadedLabels = this.uploadedHeaders.map(h => normalize(h));

    // Find missing headers (excluding optional ones)
    const missing = this.expectedFields
      .filter(f => !optionalHeaders.includes(f.label)) // skip optional in check
      .filter(f => {
        if (f.key === 'projectQty') {
          return !uploadedLabels.includes('projectqty') && !uploadedLabels.includes('projectquantity');
        }
        return !uploadedLabels.includes(normalize(f.label));
      })
      .map(f => f.label);

    // For display only, omit these EOL headers from the shown error message
    const displayExclude = ['EOL Status', 'EOL Confidence'];
    const displayMissing = missing.filter(m => !displayExclude.includes(m));

    if (missing.length > 0) {
      this.headerErrorMessage = displayMissing.length > 0 ? ('Missing headers: ' + displayMissing.join(', ')) : '';
      this.isHeaderMappingRequired = true;
    } else {
      this.isHeaderMappingRequired = false;
    }

    // Auto-map (including optional if present)
    this.reverseFieldMapping = {};
    this.tableHeaders.forEach(header => {
      const expectedField = this.expectedFields.find(f => f.key === header.key);
      if (expectedField) {
        const matchedHeader = this.uploadedHeaders.find(
          h => normalize(h) === normalize(expectedField.label) || (header.key === 'projectQty' && (normalize(h) === 'projectqty' || normalize(h) === 'projectquantity'))
        );
        this.reverseFieldMapping[header.key] = matchedHeader || null;
      }
    });
  }

  clearSourcingListFiles() {
    this.sourcingListFileName = '';
    this.form.get('sourcingListFileName')?.setValue('');
    this.sourceListData = [];
    this.sourcingRawData = [];
    this.uploadedHeaders = [];
    this.reverseFieldMapping = {};
    this.headerErrorMessage = '';
    this.isHeaderMappingRequired = false;

    const uploadInput = document.querySelector<HTMLInputElement>('.file-input');
    if (uploadInput) {
      uploadInput.value = '';
    }

    if (this.avdData && this.avdData.length > 0) {
      this.finalDataList = [...this.avdData];
      this.finalCompareDataList = [...this.finalDataList];
    } else {
      this.finalDataList = [];
      this.finalCompareDataList = [];
    }
  }

  uploadAvdFiles(event: any) {
    this.finalDataList = [];
    this.avdData = [];
    this.avdRawData = [];

    const target: DataTransfer = <DataTransfer>(event.target);
    if (!target.files || target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);

    reader.onload = (e: any) => {
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const avdExcelData: any[] = XLSX.utils.sheet_to_json(ws);
      this.avdRawData = [...avdExcelData];

      if (this.avdRawData && this.avdRawData.length > 0) {
        this.uploadedAvdHeaders = Object.keys(this.avdRawData[0]).filter(h => h !== '__rowNum__');
      } else {
        this.uploadedAvdHeaders = [];
      }

      this.validateAvdHeaders();

      this.alternatePartFileName = target.files[0].name;
      console.log(this.alternatePartFileName);
      this.form.get('alternatePartFileName')?.setValue(this.alternatePartFileName);

      // Process and apply AVD mappings
      this.applyAvdMappedData(false);
      console.log('avdData after upload', this.avdData);
    };
  }

  finalXlsx: any = [
    ['Material Number', 'Material Desc.', 'Mfr. Code', 'Manufacturer', 'Mfr.Ref']
  ]
  isN(s: any) {
    return (/^-?\d+(\.\d+)?$/.test(s)) && s.length < 4;
  }
  mergeByXPosition(data: any) {
    const grouped = new Map();

    for (const obj of data) {
      const x = obj.transform[obj.transform.length - 2]; // get X value

      if (!grouped.has(x)) {
        grouped.set(x, []);
      }

      grouped.get(x).push(obj);
    }

    const result: any = [];

    for (const [x, group] of grouped.entries()) {
      if (group.length === 1) {
        result.push(group[0]); // keep single item as is
      } else {
        // Merge all objects with same X
        const merged = {
          ...group[0], // copy first object as base
          str: group.map((o: any) => o.str).join(' '), // concatenate all str values
          hasEOL: group[group.length - 1].hasEOL // preserve EOL from last
        };
        result.push(merged);
      }
    }

    return result;
  }
  xlsxtable: any[] = [];
  async uploadPdfAndConvert(event: any) {
    const file: File = event.target.files[0];

    if (!file || !file.name.endsWith('.pdf')) {
      alert('Please upload a PDF file.');
      return;
    }

    this.alternatePartFileName = file.name;

    try {
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

      const tableData: string[][] = [];

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        let eachlastrow = textContent.items.slice(textContent.items.length - 11), lastrow = {}
        console.log('textContent', textContent)
        let fpdf: any = [], tele: any = []

        let trow = eachlastrow.filter((e: any) => e.str !== " " && e.str !== "" && e.str !== ":");

        let xtrow = this.mergeByXPosition(trow)
          .map((obj: any) => obj.str)
          .filter((str: string, index: number) => {

            if (index === 0) {
              return str.length >= 12;
            }

            if (/^-?\d+(\.\d+)?$/.test(str)) {
              return str.length >= 4;
            }
            return true; // keep all others
          });



        textContent.items.forEach((e: any, i) => {
          console.log(e)
          if (e.str === " " || e.str === "" || e.str === ":") { }
          else {

            if ((this.isN(e.str))) {

              fpdf.push(this.mergeByXPosition(tele))
              tele = []
            }
            else {
              tele.push(e)
            }
          }
          if (i === textContent.items.length - 1) {
            console.log("fpdf => ", fpdf)


            let pro = this.normalizeRows(fpdf.slice(1))
            pro.forEach((fe, fi) => {
              this.finalXlsx.push(fe.map((obj: any) => obj.str))

              console.log(pro.length - 1, "=>>", fi)
              if (pro.length - 1 === fi) {
                this.finalXlsx.push(xtrow)
                console.log(fi, 'completed Successfuly', this.finalXlsx, fpdf)

              }
            })

          }
        })

      }


      setTimeout(() => {

      }, 1000);

      this.avdData = [];
      this.avdRawData = [];

      for (let i = 1; i < this.finalXlsx.length; i++) {
        const row = this.finalXlsx[i];

        const obj = {
          internalPartNo: String(row[0] || '').trim(),        // Material Number
          manufacturer: String(row[3] || '').trim(),          // Manufacturer
          specification: String(row[2] || '').trim().replace(/\s+/g, '') // Mfr. Code as "specification"
        };

        this.avdData.push(obj);
        this.avdRawData.push(obj);
      }

      this.avdHeaderErrorMessage = '';
      this.isAvdHeaderMappingRequired = false;
      this.form.get('alternatePartFileName')?.setValue(this.alternatePartFileName);
      if (this.sourceListData && this.sourceListData.length > 0) {
        this.combineSourcingAndAvd();
      }
      this.fetchAllManufacturerMatches();
      this.cdRef.detectChanges();
      console.log("Extracted AVD Data from PDF:", this.avdData);

    } catch (error) {
      console.error("Error processing the PDF file:", error);
    }
  }

  normalizeRows(input: string[][]): string[][] {
    const result: string[][] = [];

    let i = 0;
    while (i < input.length) {
      const current = input[i];

      // Handle [2, 3] merge: next row is length 3, current is length 2
      if (current.length === 2 && input[i + 1] && input[i + 1].length === 3) {
        const next = input[i + 1];
        const merged = [...current, ...next]; // 3 first, then 2
        result.push(merged);
        i += 2; // skip next
      } else if (current.length === 5) {
        result.push(current);
        i++;
      } else {
        // Optional: pad to 5 if needed
        const padded = [...current];
        while (padded.length < 5) padded.push('');
        result.push(padded);
        i++;
      }
    }
    return result;
  }

  exportToExcel(data: any[][]) {
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'ExtractedData');
    XLSX.writeFile(wb, 'converted-from-pdf.xlsx');
  }
  xmlFile() {
    console.log("this.finalXlsx => ", this.finalXlsx)
    const dummyData: any[][] = [
      ['ID', 'Name', 'Description', 'Quantity', 'Price'],
      [1, 'Item A', 'Description of Item A', 10, '$25.00'],
      [2, 'Item B', 'Description of Item B', 5, '$15.00'],
      [3, 'Item C', 'Long description\nacross multiple lines', 20, '$10.00'],
      [4, 'Item D', 'Final item', 8, '$30.00']
    ];

  }


  isLoading = false; // Add this flag in your component

  handleFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;

    this.isLoading = true; // start loading
    this.alternatePartFileName = file.name;
    this.form.get('alternatePartFileName')?.setValue(this.alternatePartFileName);

    const fileType = file.name.toLowerCase();

    if (fileType.endsWith('.pdf')) {

      this.uploadPdfAndConvert({ target: { files: [file] } })
        .then(() => {
          this.isLoading = false; // stop loading after PDF upload completes
        })
        .catch(() => {
          this.isLoading = false; // stop loading on error as well
        });
    } else if (fileType.endsWith('.xlsx')) {

      this.uploadAvdFiles({ target: { files: [file] } });
      this.isLoading = false; // stop loading after initiating Excel upload
    } else {
      alert('Unsupported file type. Please upload a PDF or Excel (.xlsx) file.');
      this.isLoading = false; // reset loading for unsupported file
    }
  }




  clearAvdFiles() {
    // Reset local variables and form values
    this.alternatePartFileName = '';
    this.form.get('alternatePartFileName')?.setValue('');
    this.avdData = [];
    this.avdRawData = [];
    this.uploadedAvdHeaders = [];
    this.reverseAvdFieldMapping = {};
    this.avdHeaderErrorMessage = '';
    this.isAvdHeaderMappingRequired = false;

    // Ensure file input field is reset properly
    if (this.uploadAvdInputRef?.nativeElement) {
      this.uploadAvdInputRef.nativeElement.value = ''; // Clear the file input field
    } else {
      console.warn('File input is not defined. Skipping clearing input value.');
    }

    if (this.sourceListData && this.sourceListData.length > 0) {
      this.finalDataList = [...this.sourceListData];
      this.finalCompareDataList = [...this.finalDataList];
    } else {
      this.finalDataList = [];
      this.finalCompareDataList = [];
    }
  }

  combineSourcingAndAvd() {
    this.finalDataList = [];
    if (this.avdData && this.avdData.length > 0) {
      for (const avdItem of this.avdData) {
        const matchingSourceItems = this.sourceListData.filter(
          (sourceItem: any) => String(sourceItem.internalPartNo || '').trim().toLowerCase() === String(avdItem.internalPartNo || '').trim().toLowerCase()
        );

        if (matchingSourceItems.length > 0) {
          for (const sourceItem of matchingSourceItems) {
            const qtyNum = parseFloat(sourceItem.projectQty);
            const combinedRow = {
              ...avdItem,
              SlNo: sourceItem.SlNo,
              customerPartNumber: sourceItem.customerPartNumber || '',
              internalPartNo: avdItem.internalPartNo || sourceItem.internalPartNo || '',
              description: sourceItem.description || '',
              commodity: sourceItem.commodity || '',
              uom: sourceItem.uom || '',
              projectQty: !isNaN(qtyNum) ? (Number.isInteger(qtyNum) ? qtyNum : qtyNum.toFixed(2)) : (sourceItem.projectQty || ''),
              iSourcing: sourceItem.iSourcing || '',
              specification: avdItem.specification || sourceItem.specification || '',
              manufacturer: avdItem.manufacturer || sourceItem.manufacturer || '',
              eol_status: sourceItem.eol_status || '',
              eol_confidence: sourceItem.eol_confidence || '',
            };
            this.finalDataList.push(combinedRow);
          }
        }
      }

      for (const sourceItem of this.sourceListData) {
        const matchingAvdItem = this.avdData.find(
          (avdItem: any) => String(avdItem.internalPartNo || '').trim().toLowerCase() === String(sourceItem.internalPartNo || '').trim().toLowerCase()
        );

        if (!matchingAvdItem) {
          const qtyNum = parseFloat(sourceItem.projectQty);
          const combinedRow = {
            ...sourceItem,
            SlNo: sourceItem.SlNo,
            customerPartNumber: sourceItem.customerPartNumber || '',
            internalPartNo: sourceItem.internalPartNo || '',
            description: sourceItem.description || '',
            commodity: sourceItem.commodity || '',
            uom: sourceItem.uom || '',
            projectQty: !isNaN(qtyNum) ? (Number.isInteger(qtyNum) ? qtyNum : qtyNum.toFixed(2)) : (sourceItem.projectQty || ''),
            iSourcing: sourceItem.iSourcing || '',
            specification: sourceItem.specification || '',
            manufacturer: sourceItem.manufacturer || '',
            eol_status: sourceItem.eol_status || '',
            eol_confidence: sourceItem.eol_confidence || '',
          };
          this.finalDataList.push(combinedRow);
        }
      }
    } else {
      this.finalDataList = [...this.sourceListData];
    }

    this.processFinalData();
  }

  finalData() {
    this.isLoading = true; // start loading

    if ((!this.sourceListData || this.sourceListData.length === 0) && (!this.sourcingRawData || this.sourcingRawData.length === 0)) {
      this.notify.info('Please upload sourcing list');
      this.clearAvdFiles();
      this.clearSourcingListFiles();
      this.closeModal();
      this.isLoading = false;
      return;
    }

    // Ensure latest mappings are applied before comparison
    if (this.sourcingRawData && this.sourcingRawData.length > 0) {
      this.applyMappedData();
    }
    if (this.avdRawData && this.avdRawData.length > 0) {
      this.applyAvdMappedData();
    }

    this.matchedCustomerData = [];

    if (this.avdData && this.avdData.length > 0) {
      this.combineSourcingAndAvd();
    } else {
      this.notify.warning('Data processed without AVD file');
      this.finalDataList = [...this.sourceListData];
      this.processFinalData();
    }

    this.fetchAllManufacturerMatches();
    this.cdRef.detectChanges();
    console.log('Final Data List after comparison:', this.finalDataList);
    this.isLoading = false;
    this.closeModal();
  }




  processFinalData() {
    // debugger
    const uniqueDataMap = new Map<string, any>();

    for (const data of this.finalDataList) {
      // Normalize key without ignoring special characters
      const normalizeString = (value: string | number): string => {
        if (value === undefined || value === null) return '';
        return String(value).trim();
      };

      // Create a key with special characters intact
      const key = `${normalizeString(data.internalPartNo)}::${normalizeString(data.manufacturer)}::${normalizeString(data.specification)}::${Number(data.projectQty) || 0}`;

      if (!uniqueDataMap.has(key)) {
        uniqueDataMap.set(key, data); // Add unique rows
      }
    }

    // Convert the map back to a list
    this.finalDataList = Array.from(uniqueDataMap.values()).map((item, idx) => ({
      ...item,
      SlNo: idx + 1
    }));
    this.finalCompareDataList = [...this.finalDataList];

    console.log('Filtered Final Data List:', this.finalDataList);

    // Notify the user if duplicates were removed
    const originalLength = this.sourceListData.length + this.avdData.length;
    if (this.finalDataList.length < originalLength) {
      console.log('Duplicate rows have been removed.');
    }
  }

  closeUploadModal() {
    this.clearAvdFiles();
    this.clearSourcingListFiles();
    this.headerErrorMessage = '';
    this.avdHeaderErrorMessage = '';
    this.isHeaderMappingRequired = false;
    this.isAvdHeaderMappingRequired = false;

    this.closeModal();
  }

  // onClickSmartSync() {
  //   this.router.navigate(['/smart-sync'])
  // }
  onClickAnalysis() {
    this.router.navigate(['/dashboard-engineer/source-pulse'])
  }

  uploadFinalData() {
    if (!this.selectedVersionId) {
      this.notify.info('Please select version_id.');
      return;
    }

    this.isUploading = true; // Show loader   

    console.log(this.finalDataList);
    sessionStorage.setItem('project_id', this.selectedProjectId);
    sessionStorage.setItem('version_id', String(this.selectedVersionId));

    const groupedData = new Map();
    this.finalDataList
      .forEach((part: any) => {
        const internalPartNo = String(part.internalPartNo) || "";
        if (!groupedData.has(internalPartNo)) {
          groupedData.set(internalPartNo, {
            part_header: {
              internalPartNo: internalPartNo,
              customerPartNumber: String(part.customerPartNumber) || "",
              description: (String(part.description).replace(/"/g, '').replace(/\\/g, '/')) || "",
              commodity: (String(part.commodity).replace(/"/g, '').replace(/\\/g, '/')) || "",
              uom: String(part.uom) || "",
              projectQty: Number(part.projectQty) > 0 ? Number(part.projectQty) : 0,
              iSourcing: part.iSourcing == "Yes" ? "Yes" : "No",
              stockAvailability: Number(part.stockAvailability) >= 0 ? Number(part.stockAvailability) : 0,
              leadTime: Number(part.leadTime) ? Number(part.leadTime) : 0,
              minimumPrice: Number(part.minimumPrice) >= 0 ? Number(part.minimumPrice) : 0,
              authorisedSuppliers: Number(part.authorisedSuppliers) >= 0 ? Number(part.authorisedSuppliers) : 0,
              suppliers: part.suppliers && part.suppliers.length > 0
                ? part.suppliers.map((s: any) => s.supplierName)
                : [],
              eau: Number(part.eau) >= 0 ? Number(part.eau) : 0,
            },
            Parts: []
          });
        }


        const originalManufacturer = part.manufacturer;
        const selectedManufacturer = this.manufacturerOverrideMap[originalManufacturer] || originalManufacturer;


        // groupedData.get(internalPartNo).Parts.push({
        //   specification: (String(part.specification).replace(/"/g, '').replace(/\\/g, '/')) || "",
        //   manufacturer: selectedManufacturer
        // });


        //       const group = groupedData.get(internalPartNo);

        // let spec = (String(part.specification).replace(/"/g, '').replace(/\\/g, '/')) || "";

        // const addPart = (specification: string) => {
        //   if (!group.Parts.some(p => p.specification === specification && p.manufacturer === selectedManufacturer)) {
        //     group.Parts.push({
        //       specification: specification,
        //       manufacturer: selectedManufacturer
        //     });
        //   }
        // };

        // // add original spec
        // addPart(spec);

        // // SP -> STK
        // if (spec.endsWith('-SP')) {
        //   addPart(spec.replace('-SP', '-STK'));
        // }

        // // STK -> SP
        // if (spec.endsWith('-STK')) {
        //   addPart(spec.replace('-STK', '-SP'));
        // }
        const group = groupedData.get(internalPartNo);

        let spec = (String(part.specification).replace(/"/g, '').replace(/\\/g, '/')) || "";
        let manufacturer = selectedManufacturer;
        let eolStatus = part.eol_status || '';
        let eolConfidence = part.eol_confidence || '';

        const addPart = (specification: string) => {
          if (!group.Parts.some((p: any) => p.specification === specification && p.manufacturer === manufacturer)) {
            group.Parts.push({
              specification: specification,
              manufacturer: manufacturer,
              eol_status: eolStatus,
              eol_confidence: eolConfidence
            });
          }
        };

        // add original only when there is real part data
        if (spec || manufacturer) {
          addPart(spec);

          /* SP <-> STK logic */
          if (spec.endsWith('-SP')) {
            addPart(spec.replace('-SP', '-STK'));
          }

          if (spec.endsWith('-STK')) {
            addPart(spec.replace('-STK', '-SP'));
          }

          /* Alpha Wire logic */
          if (manufacturer.toLowerCase().includes('alpha wire')) {
            if (spec.endsWith('001')) {
              addPart(spec.replace(/001$/, '005'));
            }

            if (spec.endsWith('005')) {
              addPart(spec.replace(/005$/, '001'));
            }
          }

          /* Belden logic */
          if (manufacturer.toLowerCase().includes('belden')) {
            if (spec.endsWith('100')) {
              addPart(spec.replace(/100$/, '1000'));
            }

            if (spec.endsWith('1000')) {
              addPart(spec.replace(/1000$/, '100'));
            }
          }
        }

      });

    const finalPayload = {
      project_id: this.selectedProjectId,
      version_id: this.selectedVersionId,
      procurement_version_id: this.selectedEngineerData?.procurement_version_id ?? 0, // Get from selected project data from manage_projects API
      sourcing_type: this.dataPreference.length > 0 ? this.dataPreference : ['vendor'],
      data: Array.from(groupedData.values())
    };

    console.log('finalPayload', finalPayload);

    this.masterService.finalCompareData(finalPayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.isUploading = false;
          if (res) {
            this.notify.success('Data uploaded successfully...');
            this.form.reset();
            this.resetFinalData();
            this.refreshSubscription$.next();

            interval(30000)
              .pipe(take(5), takeUntil(this.refreshSubscription$), takeUntil(this.destroy$))
              .subscribe(() => {
                // Reload data with the current stage to keep user on the same tab
                const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
                this.getAllOpenProjectData(currentStage);
                this.notify.success('Data refreshed...!!!');
              });

          } else {
            this.notify.danger('Unexpected response received. Please try again.');
          }
        },
        error: (err) => {
          this.isUploading = false;
          console.error('An error occurred:', err);
          let errorMessage = 'An error occurred while uploading data. Please try again.';
          if (err?.message) {
            errorMessage = `Error: ${err.message}`;
          } else if (err?.error?.message) {
            errorMessage = `Error: ${err.error.message}`;
          }
          this.notify.danger(errorMessage);
        }
      });
  }

  selectCriteria(criteriaModal: any) {
    // Logic for selecting criteria goes here
    console.log('Criteria selected');
    this.isUploadEnabled = true; // Enable the Upload button after criteria selection.
    this.modalRef = this.modalService.open(criteriaModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  resetFinalData() {

    this.isUploadEnabled = false;
    this.sourcingListFileName = '';
    let form: any = this.form
    form.get('sourcingListFileName').setValue('');
    this.alternatePartFileName = '';
    form.get('alternatePartFileName').setValue('');
    this.sourceListData = [];
    this.avdData = [];
    this.finalDataList = [];
    this.selectedManufacturerMap = {};
    this.isDropdownVisible = {};
    this.buttonColorMap = {};
    this.buttonBorderStyle = {};
    this.allManufacturerDetailsMap = {};
    this.manufacturerOverrideMap = {};
    this.getAllcustomers();
    // Reload data with the current stage to keep user on the same tab
    const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
    this.getAllOpenProjectData(currentStage);
    this.updateTableRows();
    this.clearAllManufacturerDetails();
    this.headerErrorMessage = '';
  }

  fetchReleaseList(): void {
    this.isFetchingReleaseList = true;

    console.log('this.selectedProjectName =>', this.selectedProjectName);
    console.log('sessionStorage projectName =>', sessionStorage.getItem('projectName'));
    console.log('this.matchedCustomerData =>', this.matchedCustomerData);
    console.log('this.paginatedData =>', this.paginatedData);

    // Try multiple sources to get projectName
    let rfqNumber = String(this.selectedProjectName || '').trim();

    // If selectedProjectName is empty, try to get it from sessionStorage
    if (!rfqNumber) {
      rfqNumber = String(sessionStorage.getItem('projectName') || '').trim();
      console.log('Got projectName from sessionStorage:', rfqNumber);
    }

    // If still empty, try to get from first matched project
    if (!rfqNumber && this.matchedCustomerData && this.matchedCustomerData.length > 0) {
      rfqNumber = String(this.matchedCustomerData[0]?.projectName || '').trim();
      console.log('Got projectName from matchedCustomerData:', rfqNumber);
    }

    // If still empty, try to get from paginated data (current visible row)
    if (!rfqNumber && this.paginatedData && this.paginatedData.length > 0) {
      rfqNumber = String(this.paginatedData[0]?.projectName || '').trim();
      console.log('Got projectName from paginatedData:', rfqNumber);
    }

    // Resolve version_id for RevisionNumber
    const pData = this.selectedEngineerData || {};
    let versionId: any = this.selectedVersionId ?? pData.version_id ?? pData.versionId;

    if (versionId === undefined || versionId === null || versionId === '') {
      const storedVersion = sessionStorage.getItem('version_id');
      if (storedVersion !== null && storedVersion !== undefined && storedVersion !== '') {
        versionId = !isNaN(Number(storedVersion)) ? Number(storedVersion) : storedVersion;
      }
    }

    if (versionId === undefined || versionId === null || versionId === '') {
      if (this.matchedCustomerData && this.matchedCustomerData.length > 0) {
        versionId = this.matchedCustomerData[0]?.version_id ?? this.matchedCustomerData[0]?.versionId;
      }
    }

    if (versionId === undefined || versionId === null || versionId === '') {
      if (this.paginatedData && this.paginatedData.length > 0) {
        versionId = this.paginatedData[0]?.selectedVersionData?.version_id ?? this.paginatedData[0]?.version_id ?? this.paginatedData[0]?.versionId;
      }
    }

    if (versionId === undefined || versionId === null || versionId === '') {
      versionId = 1;
    }

    console.log('Final RfqNumber =>', rfqNumber);
    console.log('Final RevisionNumber (version_id) =>', versionId);

    if (!rfqNumber) {
      this.isFetchingReleaseList = false;
      this.notify.info('Please select an RFQ number before fetching the released list.');
      return;
    }

    const payload = {
      RfqNumber: rfqNumber,
      RevisionNumber: versionId
    };

    // Call the master service to fetch released RFQ list
    this.masterService.getRfqEnggReleasedList(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          this.isFetchingReleaseList = false;

          const apiData = Array.isArray(response?.data) ? response.data : [];

          // Validate response structure
          if ((response?.statusCode === 200 || response?.success === true) && apiData.length > 0) {
            try {
              // Map API response to finalDataList format
              this.mapApiResponseToFinalList(apiData);

              // Close modal and show preview
              this.closeModal();
              this.notify.success('Released list fetched successfully');

              console.log('Final Data List from API:', this.finalDataList);
            } catch (error) {
              console.error('Error mapping API response:', error);
              this.notify.danger('Error processing released list data');
            }
          } else {
            this.notify.warning(response?.message || 'No data received from API');
          }
        },
        error: (err: any) => {
          this.isFetchingReleaseList = false;
          console.error('Error fetching released list:', err);

          let errorMessage = 'Failed to fetch released list. Please try again.';
          if (err?.error?.message) {
            errorMessage = `Error: ${err.error.message}`;
          } else if (err?.message) {
            errorMessage = `Error: ${err.message}`;
          }
          this.notify.danger(errorMessage);
        }
      });
  }

  /**
   * Extract BOM data from /input_source_data/details POST API
   * and load into Preview Table (finalDataList)
   */
  extractTechBomHistory(): void {
    this.isExtractingHistory = true;

    const pData = this.selectedEngineerData || {};

    const projectId = Number(this.selectedProjectId ?? pData.project_id ?? pData.projectId ?? sessionStorage.getItem('project_id') ?? 0);
    const versionId = Number(this.selectedVersionId ?? pData.version_id ?? pData.versionId ?? sessionStorage.getItem('version_id') ?? 1);
    const procurementVersionId = Number(this.selectedEngineerData?.procurement_version_id ?? pData.procurement_version_id ?? pData.procurement_id ?? sessionStorage.getItem('procurement_version_id') ?? 0);

    if (!projectId || isNaN(projectId) || projectId <= 0) {
      this.isExtractingHistory = false;
      this.notify.warning('Please select a project first to extract data.');
      return;
    }

    const payload = {
      project_id: projectId,
      version_id: versionId,
      procurement_version_id: procurementVersionId
    };

    console.log('Input Source Data Details request payload =>', payload);

    this.masterService.getInputSourceDataDetails(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          this.isExtractingHistory = false;
          console.log('Input Source Data Details API response =>', response);
          let parts = this.parseInputSourceDataDetailsResponse(response);

          if (parts && parts.length > 0) {
            this.applyExtractedHistoryData(parts);
          } else {
            this.notify.warning('No extracted input source data records found for this project.');
          }
        },
        error: (err: any) => {
          this.isExtractingHistory = false;
          console.error('Error fetching input source data details:', err);
          const errorMsg = err?.error?.message || err?.message || 'Failed to extract data from Input Source Details.';
          this.notify.danger(errorMsg);
        }
      });
  }

  /**
   * Parse response from /input_source_data/details or history
   */
  private parseInputSourceDataDetailsResponse(d: any): any[] {
    if (!d) return [];

    // Direct array
    if (Array.isArray(d)) {
      return d;
    }

    // Check for source_list & not_matched structures (e.g. from AI scrubbing / merged output)
    const sourceList = d.source_list
      ?? d.data?.source_list
      ?? d.Processed_data?.final_merged_data?.source_list
      ?? d.final_merged_data?.source_list;

    const notMatchedList = d.not_matched
      ?? d.data?.not_matched
      ?? d.Processed_data?.final_merged_data?.not_matched
      ?? d.final_merged_data?.not_matched;

    if (Array.isArray(sourceList) || Array.isArray(notMatchedList)) {
      const combined: any[] = [];
      if (Array.isArray(sourceList)) {
        sourceList.forEach((item: any) => combined.push({ ...item, isMatched: true }));
      }
      if (Array.isArray(notMatchedList)) {
        notMatchedList.forEach((item: any) => combined.push({ ...item, isMatched: false }));
      }
      if (combined.length > 0) {
        return combined;
      }
    }

    // Direct properties that are arrays
    if (Array.isArray(d.data)) return d.data;
    if (Array.isArray(d.details)) return d.details;
    if (Array.isArray(d.records)) return d.records;
    if (Array.isArray(d.results)) return d.results;
    if (Array.isArray(d.cleaned_records)) return d.cleaned_records;
    if (Array.isArray(d.project_parts)) return d.project_parts;
    if (Array.isArray(d.relationships)) return d.relationships;
    if (Array.isArray(d.rows)) return d.rows;

    // Check inside d.data if it's an object
    if (d.data && typeof d.data === 'object' && !Array.isArray(d.data)) {
      if (Array.isArray(d.data.data)) return d.data.data;
      if (Array.isArray(d.data.details)) return d.data.details;
      if (Array.isArray(d.data.records)) return d.data.records;
      if (Array.isArray(d.data.results)) return d.data.results;
      if (Array.isArray(d.data.cleaned_records)) return d.data.cleaned_records;
      if (Array.isArray(d.data.project_parts)) return d.data.project_parts;
      if (Array.isArray(d.data.relationships)) return d.data.relationships;
      if (Array.isArray(d.data.rows)) return d.data.rows;

      for (const key of Object.keys(d.data)) {
        if (Array.isArray(d.data[key]) && d.data[key].length > 0) {
          return d.data[key];
        }
      }
    }

    // Check if any property in d is an array
    for (const key of Object.keys(d)) {
      if (Array.isArray(d[key]) && d[key].length > 0) {
        return d[key];
      }
    }

    return [];
  }

  /**
   * Backward-compatible alias
   */
  private parseTechBomHistoryResponse(d: any): any[] {
    return this.parseInputSourceDataDetailsResponse(d);
  }

  /**
   * Apply extracted history/input source parts to finalDataList (Preview table)
   * Comprehensively unpacks part_header, Parts arrays, alternates, and flat records.
   */
  private applyExtractedHistoryData(parts: any[]): void {
    this.finalDataList = [];
    let slNo = 1;

    parts.forEach((item: any) => {
      if (!item) return;

      // Handle nested project_parts if present
      const rawItemList = (item.project_parts && Array.isArray(item.project_parts) && item.project_parts.length > 0)
        ? item.project_parts
        : [item];

      rawItemList.forEach((rowItem: any) => {
        if (!rowItem) return;

        // Case A: rowItem has part_header / header and/or Parts / parts
        if (rowItem.part_header || rowItem.header || rowItem.Parts || rowItem.parts) {
          const header = rowItem.part_header || rowItem.header || {};
          const partsList: any[] = Array.isArray(rowItem.Parts)
            ? rowItem.Parts
            : Array.isArray(rowItem.parts)
              ? rowItem.parts
              : [];

          const cpn = String(
            header.customerPartNumber || header.customerPartNo || header.customer_part_no || header.customer_part_number || header.cpn || header.internalPartNo || ''
          ).trim();
          const ipn = String(
            header.internalPartNo || header.internalPartNumber || header.internal_part_no || header.internal_part_number || header.ipn || ''
          ).trim();
          const headerDesc = String(header.description || header.desc || '').trim();
          const headerComm = String(header.commodity || header.category || '').trim();
          const headerQty = Number(header.projectQty ?? header.project_qty ?? header.qty ?? header.quantity ?? 1) || 1;
          const headerUom = String(header.uom || 'EA').trim();
          const headerISourcing = header.iSourcing || (header.isourcing !== undefined ? (header.isourcing ? 'Yes' : 'No') : 'Yes');
          const isMatched = rowItem.isMatched ?? rowItem.match_status ?? rowItem.matched ?? true;

          if (partsList.length > 0) {
            partsList.forEach((p: any) => {
              const specVal = String(
                p.specification || p.mpn || p.mfrpn || p['Part No'] || p.part_number || p.partNo || p.mfr_part_number || header.specification || ''
              ).trim();
              const mfrVal = String(p.manufacturer || p.mfr || p.make || p.brand || header.manufacturer || '-').trim();
              const descVal = headerDesc || String(p.description || p.desc || '').trim();
              const commVal = headerComm || String(p.commodity || p.category || '').trim() || 'General';
              const qtyVal = Number(p.project_qty ?? p.projectQty ?? p.qty ?? headerQty) || headerQty;
              const uomVal = String(p.uom || headerUom || 'EA').trim();

              let eolStatus = p.eol_status || header.eol_status || '';
              if (p.sourcing_consensus?.lifecycle_consensus) {
                const lc = String(p.sourcing_consensus.lifecycle_consensus).toLowerCase();
                eolStatus = lc.includes('active') ? 'Active' : (lc.includes('eol') || lc.includes('obsolete') ? 'Obsolete' : 'Active');
              } else if (!eolStatus || eolStatus === 'Undefined') {
                eolStatus = (p.eol_status && p.eol_status !== 'Undefined') ? p.eol_status : (header.eol_status && header.eol_status !== 'Undefined' ? header.eol_status : 'Active');
              }

              let eolConf = '';
              if (p.eol_confidence !== undefined && p.eol_confidence !== null && p.eol_confidence !== '' && p.eol_confidence !== 'Undefined') {
                eolConf = String(p.eol_confidence);
              } else if (header.eol_confidence !== undefined && header.eol_confidence !== null && header.eol_confidence !== '' && header.eol_confidence !== 'Undefined') {
                eolConf = String(header.eol_confidence);
              } else if (p.candidate_confidence && specVal && p.candidate_confidence[specVal]) {
                eolConf = `${p.candidate_confidence[specVal]}%`;
              }

              const finalCpn = cpn || (specVal ? `CPN-${specVal}` : `CPN-${slNo}`);
              const finalIpn = ipn || (specVal ? `IPN-${specVal}` : `IPN-${slNo}`);

              this.finalDataList.push({
                SlNo: slNo++,
                customerPartNumber: finalCpn,
                customerPartNo: finalCpn,
                internalPartNo: finalIpn,
                description: descVal,
                specification: specVal,
                commodity: commVal,
                manufacturer: mfrVal || '-',
                uom: uomVal,
                projectQty: qtyVal,
                eol_status: eolStatus || 'Active',
                eol_confidence: eolConf,
                iSourcing: p.iSourcing || headerISourcing,
                stockAvailability: Number(header.stockAvailability) || 0,
                leadTime: Number(header.leadTime) || 0,
                minimumPrice: Number(header.minimumPrice) || 0,
                authorisedSuppliers: Number(header.authorisedSuppliers) || 0,
                suppliers: header.suppliers || [],
                eau: Number(header.eau) || 0,
                showInPayload: Boolean(isMatched)
              });
            });
          } else {
            // partsList is empty, emit single row from header
            const specVal = String(header.specification || header.mpn || header.internalPartNo || '').trim();
            const mfrVal = String(header.manufacturer || '-').trim();
            const descVal = headerDesc;
            const commVal = headerComm || 'General';
            const qtyVal = headerQty;
            const uomVal = headerUom;
            let eolStatus = header.eol_status || 'Active';
            if (eolStatus === 'Undefined') eolStatus = 'Active';
            const eolConf = (header.eol_confidence !== undefined && header.eol_confidence !== null && header.eol_confidence !== 'Undefined') ? String(header.eol_confidence) : '';

            const finalCpn = cpn || (specVal ? `CPN-${specVal}` : `CPN-${slNo}`);
            const finalIpn = ipn || (specVal ? `IPN-${specVal}` : `IPN-${slNo}`);

            this.finalDataList.push({
              SlNo: slNo++,
              customerPartNumber: finalCpn,
              customerPartNo: finalCpn,
              internalPartNo: finalIpn,
              description: descVal,
              specification: specVal,
              commodity: commVal,
              manufacturer: mfrVal || '-',
              uom: uomVal,
              projectQty: qtyVal,
              eol_status: eolStatus,
              eol_confidence: eolConf,
              iSourcing: headerISourcing,
              stockAvailability: Number(header.stockAvailability) || 0,
              leadTime: Number(header.leadTime) || 0,
              minimumPrice: Number(header.minimumPrice) || 0,
              authorisedSuppliers: Number(header.authorisedSuppliers) || 0,
              suppliers: header.suppliers || [],
              eau: Number(header.eau) || 0,
              showInPayload: Boolean(isMatched)
            });
          }
        }
        // Case B: rowItem has alternates array
        else if (rowItem.alternates && Array.isArray(rowItem.alternates) && rowItem.alternates.length > 0) {
          const cpn = String(
            rowItem.customerPartNumber || rowItem.customerPartNo || rowItem.customer_part_no || rowItem.customer_part_number || rowItem.cpn || ''
          ).trim();
          const ipn = String(
            rowItem.internalPartNo || rowItem.internalPartNumber || rowItem.internal_part_no || rowItem.internal_part_number || rowItem.ipn || ''
          ).trim();
          const desc = String(rowItem.description || rowItem.desc || '').trim();
          const comm = String(rowItem.commodity || rowItem.category || 'General').trim();
          const uom = String(rowItem.uom || 'EA').trim();
          const qty = Number(rowItem.projectQty ?? rowItem.project_qty ?? rowItem.quantity ?? rowItem.qty ?? 1) || 1;
          const isMatched = rowItem.isMatched ?? rowItem.match_status ?? rowItem.matched ?? true;

          rowItem.alternates.forEach((alt: any) => {
            const specVal = String(alt.specification || alt.mpn || alt.part_number || alt.partNo || alt.mfr_part_number || '').trim();
            const mfrVal = String(alt.manufacturer || alt.mfr || alt.make || alt.brand || '-').trim();
            const finalCpn = cpn || (specVal ? `CPN-${specVal}` : `CPN-${slNo}`);
            const finalIpn = ipn || (specVal ? `IPN-${specVal}` : `IPN-${slNo}`);

            this.finalDataList.push({
              SlNo: slNo++,
              customerPartNumber: finalCpn,
              customerPartNo: finalCpn,
              internalPartNo: finalIpn,
              description: alt.description || desc,
              specification: specVal,
              commodity: comm,
              manufacturer: mfrVal || '-',
              uom: uom,
              projectQty: qty,
              eol_status: alt.eol_status || rowItem.eol_status || 'Active',
              eol_confidence: String(alt.eol_confidence ?? rowItem.eol_confidence ?? '').trim(),
              iSourcing: rowItem.iSourcing || 'Yes',
              showInPayload: Boolean(isMatched)
            });
          });
        }
        // Case C: Flat rowItem
        else {
          const specVal = String(
            rowItem.specification || rowItem.mpn || rowItem.mfrpn || rowItem['Part No'] || rowItem.part_number || rowItem.partNo || rowItem.mfr_part_number || ''
          ).trim();
          let custPart = String(
            rowItem.customer_part_no || rowItem.customerPartNo || rowItem.customerPartNumber || rowItem.customer_part_number || rowItem.cpn || ''
          ).trim();
          let intPart = String(
            rowItem.internal_part_no || rowItem.internalPartNo || rowItem.internal_part_numbers || rowItem.internal_part_number || rowItem.ipn || rowItem.part_no || ''
          ).trim();

          if (rowItem.raw_input && (!custPart || !intPart)) {
            try {
              const raw = typeof rowItem.raw_input === 'string' ? JSON.parse(rowItem.raw_input) : rowItem.raw_input;
              if (!custPart) {
                custPart = String(raw['Customer Part No'] || raw['Customer Part Number'] || raw['CPN'] || raw['Part No'] || '').trim();
              }
              if (!intPart) {
                intPart = String(raw['Internal Part No'] || raw['Internal Part Number'] || raw['IPN'] || raw['Part No'] || '').trim();
              }
            } catch {}
          }

          const finalCpn = custPart || (specVal ? `CPN-${specVal}` : `CPN-${slNo}`);
          const finalIpn = intPart || (specVal ? `IPN-${specVal}` : `IPN-${slNo}`);
          const mfrVal = String(rowItem.manufacturer || rowItem.mfr || rowItem.make || rowItem.brand || '-').trim();
          const descVal = String(rowItem.description || rowItem.desc || '').trim();
          const commVal = String(rowItem.commodity || rowItem.category || 'General').trim();
          const uomVal = String(rowItem.uom || 'EA').trim();
          const qtyVal = Number(rowItem.project_qty || rowItem.projectQty || rowItem.quantity || rowItem.qty || 1);

          let eolStatus = rowItem.eol_status || 'Active';
          if (rowItem.sourcing_consensus?.lifecycle_consensus) {
            const lc = String(rowItem.sourcing_consensus.lifecycle_consensus).toLowerCase();
            eolStatus = lc.includes('active') ? 'Active' : (lc.includes('eol') || lc.includes('obsolete') ? 'Obsolete' : 'Active');
          }

          const eolConf = String(rowItem.eol_confidence || (rowItem.candidate_confidence && specVal && rowItem.candidate_confidence[specVal] ? `${rowItem.candidate_confidence[specVal]}%` : '')).trim();

          this.finalDataList.push({
            SlNo: slNo++,
            customerPartNumber: finalCpn,
            customerPartNo: finalCpn,
            internalPartNo: finalIpn,
            description: descVal,
            specification: specVal,
            commodity: commVal,
            manufacturer: mfrVal || '-',
            uom: uomVal,
            projectQty: qtyVal,
            eol_status: eolStatus,
            eol_confidence: eolConf,
            iSourcing: rowItem.iSourcing || 'Yes',
            showInPayload: rowItem.showInPayload !== undefined ? Boolean(rowItem.showInPayload) : true
          });
        }
      });
    });

    this.finalCompareDataList = [...this.finalDataList];
    this.sourceListData = [...this.finalDataList];
    this.isUploadEnabled = true;

    // Fetch manufacturer matches for styling buttons in the preview table
    this.finalDataList.forEach((item: any, i: number) => {
      if (item.manufacturer && item.manufacturer !== '-') {
        this.checkManufacturerMatch(item, i);
      }
    });

    this.cdRef.detectChanges();
    this.closeModal();
    this.notify.success(`Extracted ${this.finalDataList.length} parts from Input Source data! Preview table is ready.`);
  }

  /**
   * Map API response to finalDataList format
   * Transforms alternates array into proper manufacturer/specification structure
   * @param apiData Array of parts from API response
   */
  private mapApiResponseToFinalList(apiData: any[]): void {
    this.finalDataList = [];

    apiData.forEach((part: any, index: number) => {
      // Create main row with primary manufacturer (first alternate if no primary specified)
      const primaryAlternate = part.alternates && part.alternates.length > 0
        ? part.alternates[0]
        : { mpn: '', manufacturer: '' };

      const mainRow: any = {
        SlNo: index + 1,
        customerPartNumber: part.customerPartNo || '',
        internalPartNo: part.internalPartNo || '',
        description: part.description || '',
        specification: primaryAlternate.mpn || '', // Use MPN as specification
        commodity: part.commodity || '',
        manufacturer: primaryAlternate.manufacturer || '',
        uom: part.uom || '',
        projectQty: part.projectQty || 0,
        iSourcing: 'Yes'
      };

      this.finalDataList.push(mainRow);

      // Add additional rows for alternate manufacturers (if multiple alternates exist)
      if (part.alternates && part.alternates.length > 1) {
        part.alternates.slice(1).forEach((alternate: any, altIndex: number) => {
          const alternateRow: any = {
            SlNo: index + 1, // Same part number indicator
            customerPartNumber: part.customerPartNo || '',
            internalPartNo: part.internalPartNo || '',
            description: part.description || '',
            specification: alternate.mpn || '',
            commodity: part.commodity || '',
            manufacturer: alternate.manufacturer || '',
            uom: part.uom || '',
            projectQty: part.projectQty || 0,
            iSourcing: 'Yes'
          };

          this.finalDataList.push(alternateRow);
        });
      }
    });

    // Store for comparison later
    this.finalCompareDataList = [...this.finalDataList];

    // Fetch manufacturer matches for all items
    this.fetchAllManufacturerMatches();
  }

  sourcingData(): void {
    this.exportService.exportToExcel(this.sourcingDummyData, 'Source_data.xlsx', 'Source_data');
  }
  alternateData(): void {
    this.exportService.exportToExcel(this.avdDummyData, 'Avd_data.xlsx', 'Avd_DataSheet');
  }
  exportData(): void {
    this.exportService.exportToExcel(this.finalDataList, 'Final_data.xlsx', 'FinalDataSheet');
  }

  // Cleanup subscriptions when component is destroyed
  ngOnDestroy(): void {
    this.destroy$.next(); // Stop all subscriptions
    this.destroy$.complete();
    this.refreshSubscription$.next(); // Stop refresh interval
    this.refreshSubscription$.complete();
  }

  fetchAllManufacturerMatches() {
    this.sourceListData.forEach((item: any) => {
      const payloadData = {
        name: String(item.manufacturer).trim()
      };
      this.masterService.manufacturer_Name_search(payloadData).subscribe((result: any) => {
        if (result) {
          this.buttonColorMap[item.manufacturer] = result.exact_match === 1 ? 'btn-mfgs' : 'btn-mfg';
          this.allManufacturerDetailsMap[item.customerPartNumber] = result.matches; // Use customerPartNumber as key
          this.showDropdownMap[item.customerPartNumber] = false;
        } else {
          console.error('Error: Unable to retrieve manufacturer data');
          this.buttonColorMap[item.manufacturer] = 'btn-light';
        }
      });
    });
  }


  checkManufacturerMatch(item: any, index: number) {
    const uniqueKey = index;
    const payloadData = {
      name: String(item.manufacturer).trim()
    };

    this.masterService.manufacturer_Name_search(payloadData).subscribe((result: any) => {
      if (result) {
        // Add original manufacturer first, then matches
        const matches = result.matches || [];
        if (!matches.includes(item.manufacturer)) {
          matches.unshift(item.manufacturer);  // Keep original manufacturer at top
        }

        this.allManufacturerDetailsMap[uniqueKey] = matches;

        // Don't auto-select here, let user pick manually
        if (!this.selectedManufacturerMap[uniqueKey]) {
          this.selectedManufacturerMap[uniqueKey] = item.manufacturer;
        }

        console.log('Manufacturer data loaded for:', uniqueKey, this.allManufacturerDetailsMap[uniqueKey]);
      } else {
        console.error('Error: Unable to retrieve manufacturer data');
      }
    });
  }



  toggleDropdownVisibility(item: any, index: number) {
    const uniqueKey = index;
    this.isDropdownVisible[uniqueKey] = !this.isDropdownVisible[uniqueKey];

    if (this.isDropdownVisible[uniqueKey] && !this.allManufacturerDetailsMap[uniqueKey]) {
      this.checkManufacturerMatch(item, index);
      return;
    }

    if (this.isDropdownVisible[uniqueKey] && this.allManufacturerDetailsMap[uniqueKey]?.length > 0) {
      if (!this.selectedManufacturerMap[uniqueKey]) {
        const defaultValue = this.allManufacturerDetailsMap[uniqueKey][0];
        this.selectedManufacturerMap[uniqueKey] = defaultValue;


        const fakeEvent = { target: { value: defaultValue } };
        this.onManufacturerChange(fakeEvent, item, index);
      }
    }

    console.log('Dropdown visibility toggled for', uniqueKey, this.isDropdownVisible[uniqueKey]);
  }



  onManufacturerChange(event: any, item: any, index: number) {
    const selectedManufacturer = event.target.value;
    const originalManufacturer = item.manufacturer;

    this.manufacturerOverrideMap[originalManufacturer] = selectedManufacturer;

    const previousBorderStyle = this.buttonBorderStyle[index];
    this.buttonColorMap[originalManufacturer] = 'btn-mfgs';

    this.buttonBorderStyle[index] = previousBorderStyle || 'btn-mfgs';

    this.isDropdownVisible[index] = false;

    console.log(`UI override: '${originalManufacturer}' → '${selectedManufacturer}'`);

    // Call mpn-check API with the selected manufacturer and row's specification
    const payload = {
      mpn: item.specification || '',
      manufacturer: selectedManufacturer
    };

    this.mpnCheckLoading[index] = true;

    this.masterService.mpnCheck(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.mpnCheckLoading[index] = false;
          this.mpnCheckResults[index] = res;

          // Update EOL status in finalDataList
          if (res.eol_status) {
            this.finalDataList[index].eol_status = res.eol_status;
            this.finalDataList[index].eol_confidence = res.eol_date || '';
          }

          this.cdRef.detectChanges();
          this.notify.success('MPN check completed');
        },
        error: (err) => {
          this.mpnCheckLoading[index] = false;
          console.error('MPN check error:', err);
          this.notify.danger('MPN check failed');
        }
      });
  }

  clearAllManufacturerDetails() {
    this.buttonColorMap = {};
    this.allManufacturerDetails = [];
    this.showDropdownMap = {};
    this.sourceListData.forEach((item: any) => {
      const uniqueKey = item.customerPartNumber;
      this.showDropdownMap[uniqueKey] == false;
      this.buttonColorMap[uniqueKey] = '';
      this.allManufacturerDetails[uniqueKey] = [];
      this.showDropdownMap[uniqueKey] = false;

    });
    this.cdRef.detectChanges();
  }



  Data(dataPrefModal: any) {
    console.log('Data Preference clicked');
    this.modalRef = this.modalService.open(dataPrefModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  saveDataPreference() {
    console.log('Selected Data Preference:', this.dataPreference);

    this.finalDataList = this.finalDataList.map((item: any) => ({
      ...item,
      dataPreference: this.dataPreference
    }));

    setTimeout(() => {
      this.closeModal();
    }, 100);
  }

  // Initialize with selected data preferences as an array
  dataPreference: string[] = ['vendor'];

  // Function to update selection on checkbox change
  onDataPrefChange(option: string, isChecked: boolean) {
    if (isChecked) {
      if (!this.dataPreference.includes(option)) {
        this.dataPreference.push(option);
      }
    } else {
      this.dataPreference = this.dataPreference.filter(item => item !== option);
    }
  }

  // ========================================
  // AI SCRUBBING
  // ========================================
  aiScrubbingMode: boolean = false;
  aiSourceFiles: File[] = [];
  aiAvdFiles: File[] = [];
  aiSourceUploadedResponses: any[] = [];
  aiAvdUploadedResponses: any[] = [];
  isAiSourceUploading: boolean = false;
  isAiAvdUploading: boolean = false;
  isAiProcessing: boolean = false;
  aiPreviewData: any[] = [];
  aiPreviewColumns: string[] = [];
  isAiScrubbing: boolean = false;

  // MPN Check
  mpnCheckLoading: { [key: number]: boolean } = {};
  mpnCheckResults: { [key: number]: any } = {};
  showMpnAlternativesModal: boolean = false;
  selectedMpnResult: any = null;
  selectedMpnRowIndex: number = -1;

  toggleAiScrubbing(): void {
    this.aiScrubbingMode = true;
    this.aiScrubbingModalRef = this.modalService.open(this.aiScrubbingModalTemplate, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      backdrop: 'static'
    });
    this.aiScrubbingModalRef.result.then(() => { }, () => {
      this.aiScrubbingMode = false;
      this.resetAiScrubbing();
    });
  }

  closeAiScrubbingModal(): void {
    this.aiScrubbingMode = false;
    this.resetAiScrubbing();
    if (this.aiScrubbingModalRef) {
      this.aiScrubbingModalRef.close();
      this.aiScrubbingModalRef = null;
    }
  }


  onAiSourceFilesSelected(event: any): void {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;
    for (let i = 0; i < files.length; i++) {
      this.aiSourceFiles.push(files[i]);
    }
    event.target.value = '';
    this.uploadAiFiles(this.aiSourceFiles, 'source');
  }

  onAiAvdFilesSelected(event: any): void {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;
    for (let i = 0; i < files.length; i++) {
      this.aiAvdFiles.push(files[i]);
    }
    event.target.value = '';
    this.uploadAiFiles(this.aiAvdFiles, 'avd');
  }

  uploadAiFiles(files: File[], type: 'source' | 'avd'): void {
    if (type === 'source') {
      this.isAiSourceUploading = true;
    } else {
      this.isAiAvdUploading = true;
    }

    this.masterService.uploadFilesForAIScrubbing(files).subscribe({
      next: (res: any) => {
        if (type === 'source') {
          this.aiSourceUploadedResponses = Array.isArray(res) ? res : [res];
          this.isAiSourceUploading = false;
          this.notify.success('Source files uploaded successfully');
        } else {
          this.aiAvdUploadedResponses = Array.isArray(res) ? res : [res];
          this.isAiAvdUploading = false;
          this.notify.success('AVD files uploaded successfully');
        }
      },
      error: (err) => {
        console.error('AI file upload error:', err);
        if (type === 'source') {
          this.isAiSourceUploading = false;
        } else {
          this.isAiAvdUploading = false;
        }
        this.notify.danger('Failed to upload files');
      }
    });
  }

  removeAiSourceFile(index: number): void {
    this.aiSourceFiles.splice(index, 1);
    this.aiSourceUploadedResponses = [];
  }

  removeAiAvdFile(index: number): void {
    this.aiAvdFiles.splice(index, 1);
    this.aiAvdUploadedResponses = [];
  }

  resetAiScrubbing(): void {
    this.aiSourceFiles = [];
    this.aiAvdFiles = [];
    this.aiSourceUploadedResponses = [];
    this.aiAvdUploadedResponses = [];
    this.isAiSourceUploading = false;
    this.isAiAvdUploading = false;
    this.isAiProcessing = false;
    this.aiPreviewData = [];
    this.aiPreviewColumns = [];
    this.mpnCheckLoading = {};
    this.mpnCheckResults = {};
    this.showMpnAlternativesModal = false;
    this.selectedMpnResult = null;
    this.selectedMpnRowIndex = -1;
  }

  onPreviewManufacturerClick(rowIndex: number): void {
    const row = this.finalDataList[rowIndex];
    if (!row) return;

    const payload = {
      mpn: row.specification || '',
      manufacturer: row.manufacturer || ''
    };

    this.mpnCheckLoading[rowIndex] = true;

    this.masterService.mpnCheck(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.mpnCheckLoading[rowIndex] = false;
          this.mpnCheckResults[rowIndex] = res;

          // Update EOL status in finalDataList
          if (res.eol_status) {
            this.finalDataList[rowIndex].eol_status = res.eol_status;
            this.finalDataList[rowIndex].eol_confidence = res.eol_date || '';
          }

          this.cdRef.detectChanges();
          this.notify.success('MPN check completed');
        },
        error: (err) => {
          this.mpnCheckLoading[rowIndex] = false;
          console.error('MPN check error:', err);
          this.notify.danger('MPN check failed');
        }
      });
  }

  openMpnAlternativesModal(rowIndex: number): void {
    const result = this.mpnCheckResults[rowIndex];
    if (!result) {
      // If no result yet, trigger the API call first
      const row = this.finalDataList[rowIndex];
      if (!row) return;

      const payload = {
        mpn: row.specification || '',
        manufacturer: row.manufacturer || ''
      };

      this.mpnCheckLoading[rowIndex] = true;

      this.masterService.mpnCheck(payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            this.mpnCheckLoading[rowIndex] = false;
            this.mpnCheckResults[rowIndex] = res;

            if (res.eol_status) {
              this.finalDataList[rowIndex].eol_status = res.eol_status;
              this.finalDataList[rowIndex].eol_confidence = res.eol_date || '';
              if (this.aiPreviewData[rowIndex]) {
                this.aiPreviewData[rowIndex]['EOL Status'] = res.eol_status;
                this.aiPreviewData[rowIndex]['EOL Confidence'] = res.eol_date || '';
              }
            }

            this.selectedMpnResult = res;
            this.selectedMpnRowIndex = rowIndex;
            this.showMpnAlternativesModal = true;
            this.cdRef.detectChanges();
          },
          error: (err) => {
            this.mpnCheckLoading[rowIndex] = false;
            this.notify.danger('MPN check failed');
          }
        });
      return;
    }

    this.selectedMpnResult = result;
    this.selectedMpnRowIndex = rowIndex;
    this.showMpnAlternativesModal = true;
  }

  closeMpnAlternativesModal(): void {
    this.showMpnAlternativesModal = false;
    this.selectedMpnResult = null;
    this.selectedMpnRowIndex = -1;
  }


  sendAlternativeToPreview(alt: any): void {
    const rowIndex = this.selectedMpnRowIndex;
    if (rowIndex < 0 || rowIndex >= this.finalDataList.length) return;

    // Update the preview table row with the selected alternative's MPN and Manufacturer
    this.finalDataList[rowIndex].specification = alt.mpn || '';
    this.finalDataList[rowIndex].manufacturer = alt.manufacturer || '';
    this.finalDataList[rowIndex].eol_status = alt.eol_status || '';
    this.finalDataList[rowIndex].eol_confidence = alt.eol_date || '';

    // Also update aiPreviewData if it exists
    if (this.aiPreviewData[rowIndex]) {
      this.aiPreviewData[rowIndex]['Specification'] = alt.mpn || '';
      this.aiPreviewData[rowIndex]['Manufacturer(Mfg)'] = alt.manufacturer || '';
      this.aiPreviewData[rowIndex]['EOL Status'] = alt.eol_status || '';
      this.aiPreviewData[rowIndex]['EOL Confidence'] = alt.eol_date || '';
    }

    // Store the result for this row
    this.mpnCheckResults[rowIndex] = {
      ...this.selectedMpnResult,
      mpn: alt.mpn,
      manufacturer: alt.manufacturer,
      eol_status: alt.eol_status,
      eol_date: alt.eol_date
    };

    this.cdRef.detectChanges();
    this.closeMpnAlternativesModal();
    this.notify.success(`Updated row ${rowIndex + 1} with ${alt.mpn} - ${alt.manufacturer}`);
  }

  processAiData(): void {
    if (this.aiSourceUploadedResponses.length === 0 && this.aiAvdUploadedResponses.length === 0) {
      this.notify.info('Please upload at least one file before processing');
      return;
    }

    this.isAiProcessing = true;

    const payload = {
      Project_id: Number(this.selectedProjectId) || 0,
      Version_id: Number(this.selectedVersionId) || 0,
      Procuementment_id: this.selectedEngineerData?.procurement_version_id ?? 0,
      Source: this.aiSourceUploadedResponses.map(f => ({
        fileId: f.fileId || f._id,
        fileName: f.fileName,
        uploadedAt: f.uploadedAt,
        fileType: f.fileType,
        mimeType: f.mimeType
      })),
      AVD: this.aiAvdUploadedResponses.map(f => ({
        fileId: f.fileId || f._id,
        fileName: f.fileName,
        uploadedAt: f.uploadedAt,
        fileType: f.fileType,
        mimeType: f.mimeType
      }))
    };

    console.log('AI Scrubbing payload:', payload);
    this.masterService.matchEolStatus(payload).subscribe({
      next: (res: any) => {
        this.isAiProcessing = false;
        console.log('Match EOL Status API response:', JSON.stringify(res));

        let sourceList = res?.Processed_data?.final_merged_data?.source_list;
        if (!sourceList) sourceList = res?.final_merged_data?.source_list;
        if (!sourceList) sourceList = res?.source_list;
        if (!sourceList && res?.Processed_data?.final_merged_data) {
          const fmd = res.Processed_data.final_merged_data;
          if (Array.isArray(fmd)) sourceList = fmd;
        }

        console.log('Parsed source_list:', sourceList);

        if (Array.isArray(sourceList) && sourceList.length > 0) {
          console.log('=== SOURCE LIST STRUCTURE DEBUG ===');
          console.log('First source item:', sourceList[0]);
          if (sourceList[0]?.Parts && sourceList[0].Parts.length > 0) {
            console.log('First part object keys:', Object.keys(sourceList[0].Parts[0]));
            console.log('First part eol_status:', sourceList[0].Parts[0]?.eol_status);
            console.log('First part eol_confidence:', sourceList[0].Parts[0]?.eol_confidence);
          }
        }

        const notMatchedList = res?.Processed_data?.final_merged_data?.not_matched
          ?? res?.Processed_data?.not_matched
          ?? res?.final_merged_data?.not_matched
          ?? res?.not_matched
          ?? [];

        const hasSourceRows = Array.isArray(sourceList) && sourceList.length > 0;
        const hasNotMatchedRows = Array.isArray(notMatchedList) && notMatchedList.length > 0;

        if (hasSourceRows || hasNotMatchedRows) {
          this.finalDataList = [];

          if (hasSourceRows) {
            for (const item of sourceList) {
              const header = item.part_header || {};
              const parts = item.Parts || [];
              const isMatched = item.isMatched ?? item.match_status ?? item.matched ?? true;

              if (parts.length > 0) {
                for (const part of parts) {
                  console.log('Processing part:', {
                    specification: part.specification,
                    manufacturer: part.manufacturer,
                    eol_status: part.eol_status,
                    eol_confidence: part.eol_confidence,
                    allPartKeys: Object.keys(part)
                  });

                  this.finalDataList.push({
                    customerPartNumber: header.customerPartNumber || '',
                    internalPartNo: header.internalPartNo || '',
                    description: header.description || '',
                    specification: part.specification || '',
                    commodity: header.commodity || '',
                    manufacturer: part.manufacturer || '',
                    uom: header.uom || '',
                    projectQty: header.projectQty ?? '',
                    iSourcing: header.iSourcing || '',
                    eol_status: part.eol_status || '',
                    eol_confidence: part.eol_confidence || '',
                    showInPayload: Boolean(isMatched)
                  });
                }
              } else {
                this.finalDataList.push({
                  customerPartNumber: header.customerPartNumber || '',
                  internalPartNo: header.internalPartNo || '',
                  description: header.description || '',
                  specification: header.specification || '',
                  commodity: header.commodity || '',
                  manufacturer: header.manufacturer || '',
                  uom: header.uom || '',
                  projectQty: header.projectQty ?? '',
                  iSourcing: header.iSourcing || '',
                  eol_status: '',
                  eol_confidence: '',
                  showInPayload: Boolean(isMatched)
                });
              }
            }
          }

          if (hasNotMatchedRows) {
            for (const item of notMatchedList) {
              const header = item.part_header || {};
              const parts = item.Parts || [];

              if (parts.length > 0) {
                for (const part of parts) {
                  this.finalDataList.push({
                    customerPartNumber: header.customerPartNumber || '',
                    internalPartNo: header.internalPartNo || '',
                    description: header.description || '',
                    specification: part.specification || '',
                    commodity: header.commodity || '',
                    manufacturer: part.manufacturer || '',
                    uom: header.uom || '',
                    projectQty: header.projectQty ?? '',
                    iSourcing: header.iSourcing || '',
                    eol_status: part.eol_status || '',
                    eol_confidence: part.eol_confidence || '',
                    showInPayload: false
                  });
                }
              } else {
                this.finalDataList.push({
                  customerPartNumber: header.customerPartNumber || '',
                  internalPartNo: header.internalPartNo || '',
                  description: header.description || '',
                  specification: header.specification || '',
                  commodity: header.commodity || '',
                  manufacturer: header.manufacturer || '',
                  uom: header.uom || '',
                  projectQty: header.projectQty ?? '',
                  iSourcing: header.iSourcing || '',
                  eol_status: '',
                  eol_confidence: '',
                  showInPayload: false
                });
              }
            }
          }

          this.finalCompareDataList = [...this.finalDataList];

          console.log('STEP 0 - finalDataList populated from API');
          console.log('STEP 0 - Total rows:', this.finalDataList.length);
          console.log('STEP 0 - First row from finalDataList:', this.finalDataList[0]);
          console.log('STEP 0 - First row eol_status:', this.finalDataList[0]?.eol_status);
          console.log('STEP 0 - First row eol_confidence:', this.finalDataList[0]?.eol_confidence);

          this.aiPreviewColumns = [
            'Customer Part Number',
            'Internal Part Number',
            'Description',
            'Specification',
            'Commodity',
            'Manufacturer(Mfg)',
            'UOM',
            'Project Quantity',
            'I-Sourcing',
            'EOL Status',
            'EOL Confidence',
            'Status'
          ];
          this.aiPreviewData = this.finalDataList.map((item: any) => ({
            'Customer Part Number': item.customerPartNumber || '',
            'Internal Part Number': item.internalPartNo || '',
            'Description': item.description || '',
            'Specification': item.specification || '',
            'Commodity': item.commodity || '',
            'Manufacturer(Mfg)': item.manufacturer || '',
            'UOM': item.uom || '',
            'Project Quantity': item.projectQty ?? '',
            'I-Sourcing': item.iSourcing || '',
            'EOL Status': item.eol_status || '',
            'EOL Confidence': item.eol_confidence || '',
            'Status': item.showInPayload === false ? 'Not Matched' : 'Matched',
            isNotMatched: item.showInPayload === false
          }));

          console.log('STEP 1 - aiPreviewColumns defined:', this.aiPreviewColumns);
          console.log('STEP 2 - aiPreviewData length:', this.aiPreviewData.length);
          console.log('STEP 2 - First row all properties:', this.aiPreviewData[0]);
          console.log('STEP 2 - First row keys:', Object.keys(this.aiPreviewData[0]));

          if (this.aiPreviewData.length > 0) {
            const firstRow = this.aiPreviewData[0];
            console.log('STEP 3 - EOL Status from first row:', firstRow['EOL Status']);
            console.log('STEP 3 - EOL Confidence from first row:', firstRow['EOL Confidence']);
          }

          console.log('STEP 4 - Checking if EOL columns in aiPreviewColumns:', {
            hasEolStatus: this.aiPreviewColumns.includes('EOL Status'),
            hasEolConfidence: this.aiPreviewColumns.includes('EOL Confidence'),
            columnsList: this.aiPreviewColumns
          });

          console.log('finalDataList populated:', this.finalDataList.length, 'rows');

          this.cdRef.detectChanges();
          setTimeout(() => {
            this.cdRef.detectChanges();
          }, 100);

          this.tableHeaders = [
            { key: "SlNo", label: "Sl No." },
            { key: "customerPartNumber", label: "Customer Part Number" },
            { key: "internalPartNo", label: "Internal Part Number" },
            { key: "description", label: "Description" },
            { key: "specification", label: "Specification" },
            { key: "commodity", label: "Commodity" },
            { key: "manufacturer", label: "Manufacturer(Mfg)" },
            { key: "uom", label: "UOM" },
            { key: "projectQty", label: "Project Quantity" },
            { key: "eol_status", label: "EOL Status" },
            { key: "eol_confidence", label: "EOL Confidence" },
            { key: "iSourcing", label: "I-Sourcing" }
          ];
          this.showSearchRow = new Array(this.tableHeaders.length).fill(false);
          this.searchValues = new Array(this.tableHeaders.length).fill('');

          this.aiScrubbingMode = false;
          this.resetAiScrubbing();
          if (this.aiScrubbingModalRef) {
            this.aiScrubbingModalRef.close();
            this.aiScrubbingModalRef = null;
          }
          this.closeModal();
          this.notify.success('Data processed successfully — ' + (res?.Processed_data?.matched_count || 0) + ' matched, ' + (res?.Processed_data?.not_matched_count || 0) + ' not matched');
        } else {
          this.notify.warning('No processed data found in response');
          console.log('Full response for debugging:', res);
        }
      },
      error: (err) => {
        this.isAiProcessing = false;
        console.error('Match EOL Status API error:', err);
        this.notify.danger('Failed to process data');
      }
    });
  }
}


